(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-different"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-about-diff]').forEach(function (root) {
    var track = root.querySelector('[data-diff-track]');
    if (!track) return;
    function step() {
      var item = track.querySelector('.about-diff__item');
      if (!item) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
      return item.getBoundingClientRect().width + gap;
    }
    root.querySelectorAll('[data-diff-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    });
    root.querySelectorAll('[data-diff-next]').forEach(function (btn) {
      btn.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["about-team"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-about-team]').forEach(function (root) {
    var track = root.querySelector('[data-team-track]');
    if (!track) return;
    function slideStep() {
      var slide = track.querySelector('.about-team__slide');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
      return slide.getBoundingClientRect().width + gap;
    }
    root.querySelectorAll('[data-team-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () { track.scrollBy({ left: -slideStep(), behavior: 'smooth' }); });
    });
    root.querySelectorAll('[data-team-next]').forEach(function (btn) {
      btn.addEventListener('click', function () { track.scrollBy({ left: slideStep(), behavior: 'smooth' }); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-announcement-carousel]').forEach(function (root) {
      var msgs = Array.prototype.slice.call(root.querySelectorAll('[data-announcement-msg]'));
      if (msgs.length < 2) return;
      var prev = root.querySelector('[data-announcement-prev]');
      var next = root.querySelector('[data-announcement-next]');
      var i = 0, timer = null;
      var DELAY = 5000;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* Enter from below when advancing, from above when going back, so the
         direction of travel matches the arrow that was pressed. */
      function show(n, dir) {
        var from = (n + msgs.length) % msgs.length;
        msgs.forEach(function (m, k) {
          if (k === from) {
            m.style.setProperty('--msg-enter', dir < 0 ? '-100%' : '100%');
            /* Flush the offset before the class flips, or the browser
               collapses both into a single style change and nothing moves. */
            void m.offsetWidth;
            m.classList.add('is-active');
          } else {
            m.classList.remove('is-active');
            m.style.setProperty('--msg-enter', dir < 0 ? '100%' : '-100%');
          }
        });
        i = from;
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      function play() { if (!reduce) { stop(); timer = setInterval(function () { show(i + 1, 1); }, DELAY); } }

      if (prev) prev.addEventListener('click', function () { show(i - 1, -1); play(); });
      if (next) next.addEventListener('click', function () { show(i + 1, 1); play(); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', play);
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });

      play();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brushing-cards"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.brushing-cards').forEach(function (root) {
    var track = root.querySelector('[data-bc-track]');
    if (!track) return;
    function step() {
      var card = track.querySelector('.brushing-cards__card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
      return card.getBoundingClientRect().width + gap;
    }
    var prev = root.querySelector('[data-bc-prev]');
    var next = root.querySelector('[data-bc-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"] && !Shopify.designMode) return;
  try {
    
  /* Reservation clock. The drawer is replaced whole on every cart change,
     so the clock looks its element up on each tick instead of holding it.
     One deadline per browser; it starts the first time the cart is shown
     with something in it and begins again when it runs out. */
  (function () {
    var RKEY = 'clab-cart-reserve';
    function tick() {
      var drawer = document.querySelector('[data-cart-drawer]');
      var reserve = drawer && drawer.querySelector('[data-cart-reserve]');
      if (!reserve) { try { if (drawer && !drawer.querySelector('.cart-drawer__scroll')) localStorage.removeItem(RKEY); } catch (e) {} return; }
      if (drawer.getAttribute('aria-hidden') !== 'false') return;
      var out = reserve.querySelector('[data-cart-reserve-time]');
      var mins = parseInt(reserve.dataset.minutes, 10) || 10;
      var now = Date.now();
      var end = 0;
      try { end = parseInt(localStorage.getItem(RKEY), 10) || 0; } catch (e) {}
      if (!end || end <= now || end - now > mins * 60000) {
        end = now + mins * 60000;
        try { localStorage.setItem(RKEY, String(end)); } catch (e) {}
      }
      var left = Math.max(0, Math.round((end - now) / 1000));
      var sec = left % 60;
      if (out) out.textContent = Math.floor(left / 60) + ':' + (sec < 10 ? '0' : '') + sec;
    }
    setInterval(tick, 1000);
    tick();
  })();

  (function () {
    // Always look up root dynamically — refreshSection() replaces the DOM
    // node, so a closure-captured ref would go stale after the first refresh.
    function getRoot() { return document.querySelector('[data-cart-drawer]'); }

    // Next quantity for the stepper. A 3x2 line (data-pack-size) never stops
    // one short of a full pack, where it would pay as much as for the pack.
    function packStep(current, dir, itemEl) {
      const size = Number(itemEl && itemEl.dataset.packSize) || 0;
      let next = Math.max(0, current + dir);
      if (size > 1 && next > 0 && next % size === size - 1) next = Math.max(0, next + dir);
      return next;
    }

    // Thresholds are set in the shop currency (EUR). Other currencies get
    // them through Shopify's own rate, rounded up to a whole unit, so 50 €
    // reads $1,030 in Mexico and not $50.
    function shopRate() {
      const r = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate);
      return r > 0 ? r : 1;
    }
    function toLocal(cents) {
      const r = shopRate();
      return r === 1 ? cents : Math.ceil(cents * r / 100) * 100;
    }
    // Same shape as money_without_trailing_zeros in the visitor's currency:
    // the drawer prints 12345 with the money filter and this copies it.
    function moneyLabel(cents) {
      const root = getRoot();
      const m = ((root && root.dataset.moneySample) || '').match(/^(.*?)12(\D?)345(?:(\D)(0+))?(.*)$/);
      const s = m ? { pre: m[1], thou: m[2], dec: m[3] || '', places: m[4] ? m[4].length : 0, post: m[5] }
        : { pre: '', thou: '.', dec: ',', places: 2, post: '€' };
      const places = cents % 100 === 0 ? 0 : s.places;
      const [int, frac] = (cents / 100).toFixed(places).split('.');
      return s.pre + int.replace(/\B(?=(\d{3})+(?!\d))/g, s.thou) + (places ? s.dec + frac : '') + s.post;
    }
    // Liquid draws the bar in the shop currency; in any other one it comes
    // hidden (is-localizing) and is redrawn here with the converted
    // thresholds. Runs on load and after every re-render of the drawer.
    function localizeBar() {
      const box = document.querySelector('[data-cart-drawer] [data-cd-ship]');
      if (!box || !box.classList.contains('is-localizing')) return;
      const ship = box.dataset.shipLocal ? Number(box.dataset.shipLocal) : toLocal(Number(box.dataset.ship) || 0);
      const gift = toLocal(Number(box.dataset.gift) || 0);
      const total = Number(box.dataset.total) || 0;
      const reached = total >= ship;
      const giftReached = gift > 0 && (total >= gift || box.dataset.packEarned === '1');
      const max = gift || ship;
      const pct = giftReached ? 100 : (max ? Math.min(100, Math.floor(total * 100 / max)) : 0);
      const amt = (c) => '<b>' + moneyLabel(c) + '</b>';
      let text;
      if (!reached) text = (box.dataset.labelShip || '').replace('[AMOUNT]', amt(ship - total));
      else if (gift && !giftReached) text = (box.dataset.labelGift || '').replace('[AMOUNT]', amt(gift - total));
      else if (gift) text = box.dataset.labelAll || '';
      else text = box.dataset.labelShipDone || '';
      const p = box.querySelector('.cart-drawer__shipping-text');
      if (p) p.innerHTML = text;
      const fill = box.querySelector('.cart-drawer__shipping-bar-fill');
      if (fill) fill.style.width = pct + '%';
      const msShip = box.querySelector('[data-cd-ms="ship"]');
      if (msShip) {
        msShip.classList.toggle('is-reached', reached);
        if (gift) msShip.style.left = Math.floor(ship * 100 / gift) + '%';
        const b = msShip.querySelector('b'); if (b) b.textContent = moneyLabel(ship);
      }
      const msGift = box.querySelector('[data-cd-ms="gift"]');
      if (msGift) {
        msGift.classList.toggle('is-reached', giftReached);
        const b = msGift.querySelector('b'); if (b) b.textContent = moneyLabel(gift);
      }
      box.classList.toggle('is-unlocked', reached);
      box.classList.toggle('is-gift-unlocked', giftReached);
      box.classList.remove('is-localizing');
    }
    localizeBar();

    function open() {
      const r = getRoot(); if (!r) return;
      r.removeAttribute('hidden');
      void r.offsetWidth;
      r.setAttribute('data-open', 'true');
      r.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }
    function close() {
      const r = getRoot(); if (!r) return;
      r.removeAttribute('data-open');
      r.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      setTimeout(() => {
        const r2 = getRoot();
        if (r2 && r2.getAttribute('data-open') !== 'true') r2.setAttribute('hidden', '');
      }, 320);
    }

    async function refreshSection({ keepOpen = null } = {}) {
      try {
        /* Section lives inside header-group so we must fetch it by its FULL
           section ID (e.g. sections--28215593664881__cart-drawer). Fetching
           by short handle 'cart-drawer' returns a section without its
           blocks — that dropped the Shop Best Sellers block after AJAX
           removal of the last cart item. */
        const rootEl = getRoot();
        /* Adding from a carousel near the bottom re-renders the whole drawer;
           without this the shopper is thrown back to the top of the list. */
        const prevScroll = rootEl?.querySelector('.cart-drawer__scroll')?.scrollTop || 0;
        const sectionId = rootEl?.getAttribute('data-section-id') || 'cart-drawer';
        const res = await fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId), { credentials: 'same-origin' });
        const data = await res.json();
        const key = data && (data[sectionId] ? sectionId : 'cart-drawer');
        if (data && data[key]) {
          const tmp = document.createElement('div');
          tmp.innerHTML = data[key];
          const fresh = tmp.querySelector('[data-cart-drawer]');
          if (fresh) {
            const old = getRoot();
            const wasOpen = keepOpen !== null ? keepOpen : (old && old.getAttribute('data-open') === 'true');
            if (old) old.replaceWith(fresh); else document.body.appendChild(fresh);
            localizeBar();
            if (wasOpen) {
              fresh.setAttribute('data-open', 'true');
              fresh.removeAttribute('hidden');
              fresh.setAttribute('aria-hidden', 'false');
              document.documentElement.style.overflow = 'hidden';
            }
            /* Restore only AFTER `hidden` is gone: a hidden element has no
               layout, so scrollTop assignments on it are silently clamped to 0.
               Retry for a few frames while lazy images settle the height. */
            const scroller = fresh.querySelector('.cart-drawer__scroll');
            if (scroller && prevScroll) {
              let tries = 0;
              const restore = () => {
                scroller.scrollTop = prevScroll;
                if (++tries < 6 && Math.abs(scroller.scrollTop - prevScroll) > 1) {
                  setTimeout(restore, 60);
                }
              };
              setTimeout(restore, 0);
            }
          }
        }
        const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
        const cartJson = await cartRes.json();
        document.querySelectorAll('[data-cart-count]').forEach((el) => {
          el.textContent = cartJson.item_count;
          if (cartJson.item_count > 0) el.removeAttribute('hidden');
          else el.setAttribute('hidden', '');
        });
      } catch (err) { console.warn('Cart refresh failed', err); }
    }

    // Free gift: keep exactly one gift line while the cart (gift excluded)
    // is at or over the threshold, none below it. Runs on load and after any
    // cart mutation, whoever made it. Its own requests go through origFetch
    // so they never re-trigger the watcher.
    (function () {
      const origFetch = window.fetch.bind(window);
      const inflight = new Set();
      let timer = null;
      let chain = Promise.resolve();
      const conf = () => {
        const r = getRoot();
        return { vid: Number(r && r.dataset.giftVariant), min: toLocal(Number(r && r.dataset.giftThreshold)) };
      };
      const post = (url, body) => origFetch(url, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      });
      const readCart = async () => {
        const res = await origFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (!res.ok) throw new Error('cart.js ' + res.status);
        return res.json();
      };
      async function syncGift() {
        const { vid, min } = conf();
        if (!vid || !min) return false;
        try {
          let cart = await readCart();
          // A 3x2 line one unit short of a full pack (two separate adds, an
          // app) gets its free unit inside the same line.
          const topUp = {};
          cart.items.forEach((i) => {
            const p = i.properties || {};
            const n = Number(p._pack_gift) || 0;
            if (n > 1 && !p._pack_free_variant && !p._pack_free && i.quantity % n === n - 1) topUp[i.key] = i.quantity + 1;
          });
          let toppedUp = false;
          if (Object.keys(topUp).length && (await post('/cart/update.js', { updates: topUp })).ok) {
            toppedUp = true;
            cart = await readCart();
          }
          const gifts = cart.items.filter((i) => i.variant_id === vid);
          const total = cart.items.filter((i) => i.variant_id !== vid).reduce((s, i) => s + i.final_line_price, 0);
          const qty = gifts.reduce((s, i) => s + i.quantity, 0);
          // A pack that includes the gift (line property _pack_gift = its size)
          // earns it below the threshold while the line keeps that many units.
          const earned = total >= min || packGift(cart.items, vid, (i) => i.quantity);
          let changed = toppedUp;
          if (earned && qty === 0) {
            changed = (await post('/cart/add.js', { items: [{ id: vid, quantity: 1, properties: { _gift: 'Regalo' } }] })).ok;
          } else if (earned && qty > 1) {
            const updates = {}; gifts.forEach((g, n) => { updates[g.key] = n === 0 ? 1 : 0; });
            changed = (await post('/cart/update.js', { updates })).ok;
          } else if (!earned && qty > 0) {
            const updates = {}; gifts.forEach((g) => { updates[g.key] = 0; });
            changed = (await post('/cart/update.js', { updates })).ok;
          }
          // Free units of a "2 + 1" offer: a paid line carrying _pack_gift (the
          // pack size) and _pack_free_variant earns one free unit per full
          // pack, however its quantity was reached (the pack card, the
          // + button, two adds). The free line follows: added, resized or
          // removed so it always holds exactly what is earned.
          const want = freeUnitsWanted(cart.items, (i) => i.quantity);
          const frees = cart.items.filter((i) => i.properties && i.properties._pack_free);
          const fx = {};
          const toAdd = [];
          const seen = {};
          frees.forEach((f) => {
            const w = want[f.variant_id] || 0;
            if (seen[f.variant_id] || w === 0) { fx[f.key] = 0; return; }
            seen[f.variant_id] = true;
            if (f.quantity !== w) fx[f.key] = w;
          });
          Object.keys(want).forEach((v) => {
            if (want[v] > 0 && !seen[v]) toAdd.push({ id: Number(v), quantity: want[v], properties: { _pack_free: '1' } });
          });
          if (Object.keys(fx).length) changed = (await post('/cart/update.js', { updates: fx })).ok || changed;
          if (toAdd.length) changed = (await post('/cart/add.js', { items: toAdd })).ok || changed;
          if (changed) await refreshSection({ keepOpen: null });
          return changed;
        } catch (err) {
          console.warn('Gift sync failed', err);
          return false;
        }
      }
      // One sync at a time, always after every cart change still in flight,
      // so it reads the cart the shopper will actually check out with.
      const run = () => {
        clearTimeout(timer);
        chain = chain
          .then(() => Promise.allSettled(Array.from(inflight)))
          .then(syncGift)
          .catch(() => false);
        return chain;
      };
      const schedule = () => { clearTimeout(timer); timer = setTimeout(run, 250); };
      // any cart mutation made through fetch, by the theme or an app
      window.fetch = function (input, init) {
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        const p = origFetch(input, init);
        if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
          inflight.add(p);
          p.finally(() => inflight.delete(p)).catch(() => {});
          p.then(schedule, schedule);
        }
        return p;
      };

      function freeUnitsWanted(items, qtyOf) {
        const want = {};
        // Carts from before _pack_free_variant existed: the free line already
        // in the cart names the variant.
        const legacy = (items.find((i) => i.properties && i.properties._pack_free) || {}).variant_id || 0;
        items.forEach((i) => {
          const p = i.properties || {};
          if (p._pack_free) return;
          const size = Number(p._pack_gift) || 0;
          const v = Number(p._pack_free_variant) || legacy;
          if (size > 0 && v) want[v] = (want[v] || 0) + Math.floor(qtyOf(i) / size);
        });
        return want;
      }

      function packGift(items, vid, qtyOf) {
        return items.some((i) => i.variant_id !== vid && i.properties && i.properties._pack_gift && qtyOf(i) >= Number(i.properties._pack_gift));
      }

      // Given the cart and the lines about to change, the gift lines that must
      // leave in the same request because the rest drops under the threshold.
      function giftDrop(cart, changes) {
        const { vid, min } = conf();
        if (!vid || !min) return {};
        const gifts = cart.items.filter((i) => i.variant_id === vid);
        const frees = cart.items.filter((i) => i.properties && i.properties._pack_free);
        const qtyAfter = (i) => (Object.prototype.hasOwnProperty.call(changes, i.key) ? changes[i.key] : i.quantity);
        const freeOut = {};
        const wantAfter = freeUnitsWanted(cart.items, qtyAfter);
        frees.forEach((f) => { if (!wantAfter[f.variant_id]) freeOut[f.key] = 0; });
        if (!gifts.length) return freeOut;
        const total = cart.items.reduce((s, i) => {
          if (i.variant_id === vid) return s;
          const q = Object.prototype.hasOwnProperty.call(changes, i.key) ? changes[i.key] : i.quantity;
          return s + (i.quantity ? Math.round(i.final_line_price / i.quantity) * q : 0);
        }, 0);
        if (total >= min) return freeOut;
        if (packGift(cart.items, vid, qtyAfter)) return freeOut;
        const out = Object.assign({}, freeOut); gifts.forEach((g) => { out[g.key] = 0; });
        return out;
      }

      // Lets a cart action register itself before its first request, so a
      // checkout click in between still waits for it.
      const track = () => {
        let release;
        const p = new Promise((r) => { release = r; });
        inflight.add(p);
        p.then(() => inflight.delete(p));
        return release;
      };

      window.clabGift = { conf, readCart, giftDrop, run, track };

      // Checkout never leaves before pending cart changes and the gift check
      // have finished: a quick remove + checkout can no longer carry the gift
      // under the threshold. Covers the drawer link and the cart page form.
      const goCheckout = async (el, href, before) => {
        if (el.dataset.cdBusy) return;
        el.dataset.cdBusy = '1';
        el.setAttribute('aria-busy', 'true');
        try {
          if (before) await before();
          await run();
        } catch (err) { console.warn('Checkout guard', err); }
        window.location.href = href;
      };
      document.addEventListener('click', (e) => {
        const a = e.target && e.target.closest && e.target.closest('a[href$="/checkout"], a[href*="/checkout?"]');
        if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
        if (!conf().vid) return;
        e.preventDefault();
        goCheckout(a, a.href);
      }, true);
      document.addEventListener('submit', (e) => {
        const form = e.target;
        const btn = e.submitter;
        if (!form || !btn || btn.name !== 'checkout' || !conf().vid) return;
        if (!/\/cart\/?$/.test(new URL(form.action, location.href).pathname)) return;
        e.preventDefault();
        const data = new FormData(form);
        const cartPath = new URL(form.action, location.href).pathname.replace(/\/$/, '');
        goCheckout(btn, cartPath + '/checkout', () =>
          fetch(cartPath + '/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: data }));
      }, true);

      document.addEventListener('cart:item-added', schedule);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
      else schedule();
    })();

    // Delegated open/close
    document.addEventListener('click', (e) => {
      const opener = e.target && e.target.closest && e.target.closest('[data-cart-drawer-open], [data-cart-link]');
      if (opener) { e.preventDefault(); open(); return; }
      const closer = e.target && e.target.closest && e.target.closest('[data-cart-drawer-close]');
      if (closer) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', (e) => {
      const r = getRoot();
      if (e.key === 'Escape' && r && r.getAttribute('data-open') === 'true') close();
    });

    // Line item keys are regenerated whenever the cart changes, so a key read
    // off the rendered card can already be stale by the time it is used — and
    // update.js falls back to matching a stale key by variant, which takes out
    // the wrong line. Bundle lines are always looked up live by their
    // _bundleId instead.
    async function bundleLines(bundleId) {
      const cart = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' }).then((r) => r.json());
      return (cart.items || []).filter((i) => i.properties && i.properties._bundleId === bundleId);
    }
    async function removeLines(lines) {
      if (!lines.length) return;
      let updates = {};
      lines.forEach((l) => { updates[l.key] = 0; });
      if (window.clabGift && window.clabGift.conf().vid) {
        try { updates = Object.assign(window.clabGift.giftDrop(await window.clabGift.readCart(), updates), updates); } catch (err) { /* the gift sync still runs after */ }
      }
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates })
      });
    }

    // Removing a bundle takes every line of the pack out in one update, so the
    // box never survives half-emptied.
    document.addEventListener('click', async (e) => {
      const btn = e.target && e.target.closest && e.target.closest('[data-cd-bundle-remove]');
      if (!btn) return;
      e.preventDefault();
      const bundleId = btn.dataset.bundleId;
      if (!bundleId) return;
      const release = window.clabGift ? window.clabGift.track() : () => {};
      try {
        const lines = await bundleLines(bundleId);
        let cfg = null;
        try { cfg = JSON.parse((lines[0] && lines[0].properties._bundleCfg) || 'null'); } catch (err) { cfg = null; }
        await removeLines(lines);
        // One box fewer can drop the cart to a lower tier (6 → 3).
        if (cfg && window.clabLoopBundle) await window.clabLoopBundle.syncDiscount(cfg);
        await refreshSection({ keepOpen: true });
      } catch (err) { console.warn('Bundle remove failed', err); }
      finally { release(); }
    });

    // Moving a bundle onto its subscription plan: Loop wants a fresh
    // transaction for the new configuration, so the pack is re-added rather
    // than patched line by line. The old lines only go once the new ones are
    // in, so a failure halfway leaves the shopper's pack untouched.
    document.addEventListener('click', async (e) => {
      const btn = e.target && e.target.closest && e.target.closest('[data-cd-bundle-subscribe]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      let cfg;
      try { cfg = JSON.parse(btn.dataset.cfg); } catch (err) { return; }
      const bundleId = btn.dataset.bundleId;
      const plan = parseInt(cfg.sellingPlanId, 10);
      if (!bundleId || !plan) return;
      btn.disabled = true;
      try {
        const oldLines = await bundleLines(bundleId);
        const variants = oldLines.map((l) => ({ id: l.variant_id, quantity: l.quantity }));
        if (!variants.length) throw new Error('pack not in cart');
        const txnRes = await fetch(cfg.api + '/bundle/' + cfg.bundleId + '/transaction?myshopifyDomain=' + encodeURIComponent(cfg.shop), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            boxSizeId: cfg.boxSizeId,
            sellingPlanShopifyId: plan,
            quantity: 1,
            productVariants: variants.map((v) => ({ shopifyId: v.id, quantity: v.quantity }))
          })
        });
        const txn = await txnRes.json();
        const txnId = txn && txn.data && txn.data.txnId;
        if (!txnId) throw new Error('no transaction');
        const items = variants.map((v) => ({
          id: v.id,
          quantity: v.quantity,
          selling_plan: plan,
          properties: {
            _bundleId: txnId,
            _bundleName: btn.dataset.name || '',
            _bundleCfg: btn.dataset.cfg,
            _bundlePct: String(cfg.planPercent || 0),
            _bundleOff: String(cfg.discountValue || 0)
          }
        }));
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items })
        });
        if (!addRes.ok) throw new Error('add failed');
        await removeLines(await bundleLines(bundleId));
        if (window.clabLoopBundle) {
          await window.clabLoopBundle.syncDiscount(cfg);
        } else if (cfg.discountCode) {
          await fetch('/discount/' + encodeURIComponent(cfg.discountCode), { credentials: 'same-origin' });
        }
      } catch (err) {
        console.warn('Bundle subscribe failed', err);
      }
      try { await refreshSection({ keepOpen: true }); } catch (err) { /* section refresh is best effort */ }
    });

    // Delegated qty + remove + subscribe pill
    document.addEventListener('click', async (e) => {
      const qty = e.target && e.target.closest && e.target.closest('[data-cd-qty]');
      const remove = e.target && e.target.closest && e.target.closest('[data-cd-remove]');
      const subscribe = e.target && e.target.closest && e.target.closest('[data-cd-subscribe]');
      if (!qty && !remove && !subscribe) return;
      e.preventDefault();
      const key = (qty || remove || subscribe).dataset.key;
      if (!key) return;
      let body;
      if (remove) {
        body = JSON.stringify({ id: key, quantity: 0 });
      } else if (subscribe) {
        /* Swap the line item to its first selling plan (subscribe & save). */
        const planId = subscribe.dataset.sellingPlanId;
        if (!planId) return;
        body = JSON.stringify({ id: key, selling_plan: planId });
      } else {
        const itemEl = qty.closest('[data-cd-item]');
        const valEl = itemEl ? itemEl.querySelector('.cart-drawer__qty-value') : null;
        const current = valEl ? parseInt(valEl.textContent, 10) : 1;
        const dir = qty.dataset.cdQty === 'inc' ? 1 : -1;
        const next = packStep(current, dir, itemEl);
        body = JSON.stringify({ id: key, quantity: next });
      }
      const release = window.clabGift ? window.clabGift.track() : () => {};
      try {
        // Lowering a line can drop the cart under the gift threshold. The gift
        // then leaves in the very same request, so there is no moment where
        // the cart is under 80 with the gift still in it.
        if (!subscribe && window.clabGift && window.clabGift.conf().vid) {
          const cart = await window.clabGift.readCart();
          const line = cart.items.find((i) => i.key === key);
          if (line) {
            const nextQty = remove ? 0 : packStep(line.quantity, qty.dataset.cdQty === 'inc' ? 1 : -1, qty.closest('[data-cd-item]'));
            const drop = nextQty < line.quantity ? window.clabGift.giftDrop(cart, { [key]: nextQty }) : {};
            if (Object.keys(drop).length) {
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ updates: Object.assign({ [key]: nextQty }, drop) })
              });
              await refreshSection({ keepOpen: true });
              return;
            }
          }
        }
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body
        });
        await refreshSection({ keepOpen: true });
      } catch (err) { console.warn('Cart change failed', err); }
      finally { release(); }
    });

    // Recommendation carousels: add a single-variant product without leaving the drawer
    document.addEventListener('click', async (e) => {
      const add = e.target && e.target.closest && e.target.closest('[data-cd-add]');
      if (!add || add.disabled) return;
      e.preventDefault();
      const variantId = add.dataset.variantId;
      if (!variantId) return;
      const label = add.querySelector('.cart-drawer__rec-add-label');
      const previous = label ? label.textContent : '';
      add.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [Object.assign({ id: Number(variantId), quantity: 1 },
            add.dataset.sellingPlan ? { selling_plan: Number(add.dataset.sellingPlan) } : {})] })
        });
        if (!res.ok) throw new Error('add failed');
        add.classList.add('is-added');
        if (label) label.textContent = (window.themeI18n || {}).added_plain || 'Added';
        await refreshSection({ keepOpen: true });
      } catch (err) {
        console.warn('Cart add failed', err);
        add.disabled = false;
        add.classList.remove('is-added');
        if (label) label.textContent = previous;
      }
    });

    // External trigger: PDP add-to-cart fires this → refresh + open
    document.addEventListener('cart:item-added', async () => {
      await refreshSection({ keepOpen: true });
      open();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["choose-routine"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-choose-routine]').forEach((root) => {
      const tabs = root.querySelectorAll('[data-tab]');
      const panels = root.querySelectorAll('[data-tab-panel]');
      if (!tabs.length || !panels.length) return;

      /* Progress-bar thumbs are siblings of their panels, keyed by
         data-scrollbar-for="<slug>". */
      const bars = root.querySelectorAll('[data-scrollbar-for]');

      function updateBar(panel) {
        const slug = panel.dataset.tabPanel;
        const bar = root.querySelector(`[data-scrollbar-for="${slug}"]`);
        if (!bar) return;
        const thumb = bar.querySelector('[data-thumb]');
        if (!thumb) return;
        const scrollW = panel.scrollWidth;
        const clientW = panel.clientWidth;
        /* Bar always visible when rendered; if the panel isn't overflowing
           the thumb just fills the bar (100%). Never hide via JS. */
        const ratio = clientW > 0 && scrollW > 0
          ? Math.min(1, clientW / scrollW)
          : 1;
        const barW = bar.clientWidth;
        const thumbW = Math.max(20, Math.round(barW * ratio));
        thumb.style.width = thumbW + 'px';
        const maxScroll = Math.max(0, scrollW - clientW);
        const progress = maxScroll > 0 ? panel.scrollLeft / maxScroll : 0;
        const maxX = Math.max(0, barW - thumbW);
        thumb.style.transform = `translateX(${Math.round(progress * maxX)}px)`;
      }

      function bindPanel(panel) {
        let ticking = false;
        const onScroll = () => {
          if (!ticking) {
            requestAnimationFrame(() => { updateBar(panel); ticking = false; });
            ticking = true;
          }
        };
        panel.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', () => updateBar(panel));
        updateBar(panel);
        /* Hide the bar for panels that start hidden (only the first tab
           is active on load). Active tab's bar stays visible. */
        const slug = panel.dataset.tabPanel;
        const bar = root.querySelector(`[data-scrollbar-for="${slug}"]`);
        if (bar) bar.hidden = panel.hasAttribute('hidden');
      }

      function activate(slug) {
        tabs.forEach((t) => {
          const on = t.dataset.tab === slug;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach((p) => {
          if (p.dataset.tabPanel === slug) {
            p.removeAttribute('hidden');
            updateBar(p);
          } else {
            p.setAttribute('hidden', '');
          }
        });
        bars.forEach((b) => {
          b.hidden = b.dataset.scrollbarFor !== slug;
        });
      }

      /* Sliding pill. Follows whichever tab is hovered and settles back on
         the active one; positions come from offsetLeft/offsetWidth so it
         tracks the real layout rather than a hard-coded step. */
      const pill = root.querySelector('[data-tab-pill]');
      function movePill(target) {
        if (!pill || !target) return;
        pill.style.setProperty('--pill-x', target.offsetLeft + 'px');
        pill.style.setProperty('--pill-w', target.offsetWidth + 'px');
        pill.classList.add('is-ready');
      }
      function pillToActive() { movePill(root.querySelector('.choose-routine__tab.is-active')); }

      tabs.forEach((t) => {
        t.addEventListener('click', () => { activate(t.dataset.tab); movePill(t); });
        t.addEventListener('mouseenter', () => movePill(t));
      });
      const tabsBar = root.querySelector('.choose-routine__tabs');
      if (tabsBar) tabsBar.addEventListener('mouseleave', pillToActive);
      window.addEventListener('resize', pillToActive);
      requestAnimationFrame(pillToActive);

      panels.forEach(bindPanel);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clinical-stats"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Shopify's video_tag does not always emit the attributes a browser needs
    // before it will start a background video on its own.
    document.querySelectorAll('.clinical-stats video').forEach(function (v) {
      v.muted = true;
      v.defaultMuted = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.loop = true;
      v.removeAttribute('controls');
      var go = v.play();
      if (go && go.catch) go.catch(function () {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clinically-proven"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-clinically-proven]').forEach(function (root) {
      var nums = Array.prototype.slice.call(root.querySelectorAll('[data-countup]'));
      if (!nums.length) return;
      var items = [];
      nums.forEach(function (el) {
        var raw = el.getAttribute('data-countup') || el.textContent;
        var m = raw.match(/^\s*([\d.,]+)(.*)$/);
        if (!m) return;
        var numStr = m[1].replace(',', '.');
        var decimals = (numStr.split('.')[1] || '').length;
        items.push({ el: el, target: parseFloat(numStr), suffix: m[2], decimals: decimals });
        if (!reduce) el.textContent = (0).toFixed(decimals) + m[2];
      });
      if (reduce || !items.length) return;
      var done = false;
      function run() {
        if (done) return; done = true;
        items.forEach(function (it) {
          var start = null, dur = 1300;
          function step(ts) {
            if (start === null) start = ts;
            var p = Math.min(1, (ts - start) / dur);
            var eased = 1 - Math.pow(1 - p, 3);
            it.el.textContent = (it.target * eased).toFixed(it.decimals) + it.suffix;
            if (p < 1) requestAnimationFrame(step);
            else it.el.textContent = it.target.toFixed(it.decimals) + it.suffix;
          }
          requestAnimationFrame(step);
        });
      }
      if (!('IntersectionObserver' in window)) { run(); return; }
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) { if (en.isIntersecting) { run(); io.disconnect(); } });
      }, { threshold: 0.3 });
      io.observe(root);

      /* Reveal watches the scale card itself, not the whole section: the
         section is taller than most viewports, so a ratio threshold on it is
         far harder to satisfy than on the card. */
      var scale = root.querySelector('.clinically-proven__scale');
      if (scale && !reduce) {
        var rio = new IntersectionObserver(function (ents) {
          ents.forEach(function (en) {
            if (en.isIntersecting) { scale.classList.add('is-revealed'); rio.disconnect(); }
          });
        }, { threshold: 0.15 });
        rio.observe(scale);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["creators-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Creators strip: driven from JS so hovering no longer pauses it and it
       can be dragged either way. One loop is half the strip plus half a gap
       (see the keyframes), crossed in --cb-speed seconds like the CSS
       version. After a drag it glides with the throw and eases back. */
    function start(view) {
      if (view.__cbDrag) return;
      view.__cbDrag = true;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var strip = view.querySelector('.creators-bar__marquee');
      if (!strip) return;
      view.classList.add('is-draggable');

      var x = 0, loop = 0, secs = 45, vel = 0, last = 0, visible = true;
      var down = false, dragging = false, startX = 0, startY = 0, startOff = 0, lastX = 0, lastT = 0;

      function measure() {
        var cs = getComputedStyle(strip);
        var gap = parseFloat(cs.columnGap) || 0;
        loop = strip.offsetWidth / 2 + gap / 2;
        var vs = getComputedStyle(view);
        secs = parseFloat(vs.getPropertyValue(window.matchMedia('(max-width: 749px)').matches ? '--cb-speed-mob' : '--cb-speed')) || 45;
      }
      function cruise() { return loop / secs; }
      function wrap() { if (loop > 0) x = ((x % loop) + loop) % loop; }
      function paint() { strip.style.transform = 'translate3d(' + (-x).toFixed(2) + 'px,0,0)'; }

      function tick(t) {
        var dt = last ? Math.min(0.05, (t - last) / 1000) : 0;
        last = t;
        if (!dragging && visible && loop > 0) {
          vel += (cruise() - vel) * Math.min(1, dt * 2.2);
          x += vel * dt;
          wrap();
          paint();
        }
        requestAnimationFrame(tick);
      }

      function onMove(e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!dragging) {
          if (Math.abs(dx) < 6) return;
          if (e.pointerType !== 'mouse' && Math.abs(e.clientY - startY) > Math.abs(dx)) { onUp(); return; }
          dragging = true;
          view.classList.add('is-dragging');
        }
        x = startOff - dx;
        wrap();
        paint();
        var now = performance.now();
        var dtm = (now - lastT) / 1000;
        if (dtm > 0) vel = -(e.clientX - lastX) / dtm;
        lastX = e.clientX;
        lastT = now;
      }
      function onUp() {
        if (!down) return;
        down = false;
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
        window.removeEventListener('pointercancel', onUp);
        if (!dragging) return;
        dragging = false;
        view.classList.remove('is-dragging');
        if (performance.now() - lastT > 90) vel = 0;
        vel = Math.max(-2500, Math.min(2500, vel));
      }
      view.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        down = true;
        startX = lastX = e.clientX;
        startY = e.clientY;
        startOff = x;
        lastT = performance.now();
        window.addEventListener('pointermove', onMove);
        window.addEventListener('pointerup', onUp);
        window.addEventListener('pointercancel', onUp);
      });
      view.addEventListener('dragstart', function (e) { e.preventDefault(); });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }).observe(view);
      }
      measure();
      window.addEventListener('resize', measure);
      window.addEventListener('load', measure);
      requestAnimationFrame(tick);
    }
    function init() { document.querySelectorAll('.creators-bar__viewport').forEach(start); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dentist"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-dentist-slider]').forEach((root) => {
      const thumbs = root.querySelectorAll('[data-slide-thumb]');
      const photos = root.querySelectorAll('[data-slide-photo]');
      const texts = root.querySelectorAll('[data-slide-text]');
      if (!thumbs.length) return;

      function activate(idx) {
        thumbs.forEach((t) => {
          const on = Number(t.dataset.slideThumb) === idx;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        photos.forEach((p) => p.classList.toggle('is-active', Number(p.dataset.slidePhoto) === idx));
        texts.forEach((tx) => tx.classList.toggle('is-active', Number(tx.dataset.slideText) === idx));
      }

      thumbs.forEach((t) => t.addEventListener('click', () => activate(Number(t.dataset.slideThumb))));

      /* Wire prev/next arrows to cycle through slides. */
      const total = thumbs.length;
      root.parentElement.querySelectorAll('[data-dir]').forEach((btn) => {
        btn.addEventListener('click', () => {
          let cur = 0;
          thumbs.forEach((t, i) => { if (t.classList.contains('is-active')) cur = i; });
          const next = btn.dataset.dir === 'prev' ? (cur - 1 + total) % total : (cur + 1) % total;
          activate(next);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dual-active"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Safari and Chrome both drop autoplay attributes set by the theme editor
       re-render, and a muted/playsInline pair assigned as properties is the
       only combination they honour consistently. */
    function arm(video) {
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.loop = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }
    function armAll() {
      document.querySelectorAll('.dual-active__media-video').forEach(function (video) {
        if (video.dataset.daArmed === '1') return;
        video.dataset.daArmed = '1';
        if (!('IntersectionObserver' in window)) { arm(video); return; }
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              video.preload = 'auto';
              arm(video);
            } else if (!video.paused) {
              video.pause();
            }
          });
        }, { rootMargin: '300px 0px' });
        io.observe(video);
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', armAll);
    } else {
      armAll();
    }
    document.addEventListener('shopify:section:load', armAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dual-tech"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function arm(root) {
      if (!root || root.dataset.dtArmed === '1') return;
      root.dataset.dtArmed = '1';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) { root.classList.add('is-active'); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            root.classList.add('is-active');
            io.disconnect();
          }
        });
      }, { threshold: 0.35 });
      io.observe(root.querySelector('[data-dt-stage]') || root);
    }
    function armAll() { document.querySelectorAll('[data-dual-tech]').forEach(arm); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armAll);
    else armAll();
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-dual-tech]') : null;
      if (root) { root.dataset.dtArmed = ''; arm(root); }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flavor-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-fs-group]').forEach(function (group) {
    var track = group.querySelector('[data-fs-track]');
    if (!track) return;
    function step() {
      var tile = track.querySelector('.flavor-showcase__tile');
      if (!tile) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
      return tile.getBoundingClientRect().width + gap;
    }
    var prev = group.querySelector('[data-fs-prev]');
    var next = group.querySelector('[data-fs-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    /* Scroll bar (phones): thumb sized to the visible share of the strip. */
    var thumb = group.querySelector('[data-fs-bar]');
    if (thumb) {
      var bar = thumb.parentNode;
      var sync = function () {
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 1) { bar.style.visibility = 'hidden'; return; }
        bar.style.visibility = '';
        var share = track.clientWidth / track.scrollWidth;
        var w = bar.clientWidth;
        thumb.style.width = (share * 100) + '%';
        thumb.style.transform = 'translateX(' + ((track.scrollLeft / max) * (w - w * share)).toFixed(1) + 'px)';
      };
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      window.addEventListener('load', sync);
      sync();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["formula-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Scroll-bound reveal. Progress runs from the moment the list's top
       crosses 75% of the viewport until it has travelled 85% of the
       viewport further up. Each active owns a slice of that progress: its
       bar lights at the start of the slice and its body unfolds across it.
       A short lerp smooths the scroll so the motion trails the finger. */
    function setup(root) {
      if (!root || root.dataset.fxArmed === '1') return;
      root.dataset.fxArmed = '1';
      var list = root.querySelector('[data-fx-index]');
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-fx-item]'));
      if (!list || !items.length) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce) { root.classList.add('is-static'); return; }

      /* Slices 0.22 apart (three actives end at 0.64); more than three are
         squeezed so the last one is fully open by 0.88, never cut off. */
      var SPAN = 0.12;
      var STEP = items.length > 1 ? Math.min(0.22, (0.88 - SPAN - 0.08) / (items.length - 1)) : 0;
      var STARTS = items.map(function (_, k) { return 0.08 + k * STEP; });
      var heights = [], target = 0, current = -1, raf = null;

      function measure() {
        heights = items.map(function (it) {
          var inner = it.querySelector('[data-fx-inner]');
          return inner ? inner.scrollHeight : 0;
        });
      }
      function progress() {
        var vh = window.innerHeight || 800;
        var top = list.getBoundingClientRect().top;
        return Math.max(0, Math.min(1, (vh * 0.75 - top) / (vh * 0.85)));
      }
      function paint(p) {
        items.forEach(function (it, k) {
          var start = STARTS[k];
          var f = Math.max(0, Math.min(1, (p - start) / SPAN));
          var eased = f * f * (3 - 2 * f);
          var panel = it.querySelector('[data-fx-panel]');
          var inner = it.querySelector('[data-fx-inner]');
          if (panel) panel.style.height = (heights[k] * eased).toFixed(1) + 'px';
          if (inner) inner.style.opacity = eased.toFixed(3);
          it.classList.toggle('is-lit', f > 0.02);
        });
      }
      function tick() {
        current += (target - current) * 0.16;
        if (Math.abs(target - current) < 0.0015) { current = target; paint(current); raf = null; return; }
        paint(current);
        raf = requestAnimationFrame(tick);
      }
      function onScroll() {
        target = progress();
        if (current < 0) { current = target; paint(current); return; }
        if (!raf) raf = requestAnimationFrame(tick);
      }
      measure();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { measure(); current = -1; onScroll(); });
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { measure(); paint(current < 0 ? 0 : current); });
      onScroll();
    }

    /* Video: preload=none, fetched and played only once the section is near. */
    function armVideos() {
      document.querySelectorAll('[data-fg-video]').forEach(function (video) {
        if (video.dataset.fgArmed === '1') return;
        video.dataset.fgArmed = '1';
        var play = function () {
          video.muted = true; video.defaultMuted = true; video.playsInline = true; video.loop = true;
          if (video.preload !== 'auto') video.preload = 'auto';
          var p = video.play(); if (p && p.catch) p.catch(function () {});
        };
        if (!('IntersectionObserver' in window)) { play(); return; }
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) play();
            else if (!video.paused) video.pause();
          });
        }, { rootMargin: '300px 0px' }).observe(video);
      });
    }

    function init() {
      document.querySelectorAll('[data-formula-grid]').forEach(setup);
      armVideos();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target && e.target.querySelector ? e.target.querySelector('[data-formula-grid]') : null;
      if (root) { root.dataset.fxArmed = ''; setup(root); }
      armVideos();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;
    const mega = header.querySelector('[data-mega]');
    if (!mega) return;

    const desktopMQ = window.matchMedia('(min-width: 1024px)');
    const triggers = header.querySelectorAll('.site-header__inner--desk .site-header__nav-link');
    const cats = mega.querySelectorAll('[data-mega-cat]');
    const panels = mega.querySelectorAll('[data-mega-panel]');

    // Build map: trigger label (lowercase) → first matching category slug
    const triggerMap = {};
    cats.forEach((c) => {
      const trig = (c.dataset.megaTrigger || '').trim().toLowerCase();
      if (trig && !triggerMap[trig]) triggerMap[trig] = c.dataset.megaCat;
    });

    var scrim = document.querySelector('.site-header__scrim');
    function placeScrim() {
      if (!scrim) return;
      var top = Math.max(0, Math.round(header.getBoundingClientRect().top));
      scrim.style.setProperty('--scrim-top', top + 'px');
    }
    function open() {
      if (!desktopMQ.matches) return;
      placeScrim();
      header.setAttribute('data-mega-open', 'true');
    }
    /* Kept in this closure: placeScrim is defined here, and calling it from
       the sticky block threw and killed that block's scroll listener. */
    window.addEventListener('scroll', function () {
      if (header.getAttribute('data-mega-open') === 'true') placeScrim();
    }, { passive: true });
    window.addEventListener('resize', placeScrim);
    function close() {
      header.removeAttribute('data-mega-open');
    }

    // Hover reveal: hovering ANY desktop nav link OR the megamenu itself keeps it open
    let hoverFlag = false;
    let hideTimer;

    function linkLabel(t) {
      const span = t.querySelector('.site-header__nav-label');
      return ((span ? span.textContent : t.textContent) || '').trim().toLowerCase();
    }

    function maybeOpen(e) {
      if (!desktopMQ.matches) return;
      // If any block has a trigger_label set, only open when the hovered link matches
      const hasTriggers = Object.keys(triggerMap).length > 0;
      if (e && e.currentTarget && hasTriggers) {
        /* The server marks the trigger link (has-mega); the label map is
           only the fallback for markup without that class. */
        const label = linkLabel(e.currentTarget);
        if (!e.currentTarget.classList.contains('has-mega') && !triggerMap[label]) return; // not a megamenu trigger; bail
        /* Opens neutral on the Bestsellers panel; a category only takes over
           once the cursor reaches it. */
        activate('__default');
      }
      hoverFlag = true;
      clearTimeout(hideTimer);
      open();
    }
    function maybeClose() {
      hoverFlag = false;
      clearTimeout(hideTimer);
      /* Longer delay + hover-bridge below the nav link gives the cursor time
         to reach the mega panel without the menu closing under it. */
      hideTimer = setTimeout(() => { if (!hoverFlag) close(); }, 260);
    }

    triggers.forEach((t) => {
      t.addEventListener('mouseenter', maybeOpen);
      t.addEventListener('focus', (e) => maybeOpen(e));
    });
    mega.addEventListener('mouseenter', () => { hoverFlag = true; clearTimeout(hideTimer); });
    /* Close only when the cursor leaves the WHOLE header block. That way
       the trigger-to-panel transition and any dead-zone between nav links
       and the mega panel no longer risk closing the menu. */
    header.addEventListener('mouseleave', maybeClose);
    header.addEventListener('mouseenter', () => { hoverFlag = true; clearTimeout(hideTimer); });

    // Category switching
    function activate(slug) {
      cats.forEach((c) => {
        const on = c.dataset.megaCat === slug;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach((p) => {
        if (p.dataset.megaPanel === slug) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
    }
    cats.forEach((c) => {
      c.addEventListener('mouseenter', () => activate(c.dataset.megaCat));
      c.addEventListener('focus', () => activate(c.dataset.megaCat));
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });

    desktopMQ.addEventListener && desktopMQ.addEventListener('change', () => {
      if (!desktopMQ.matches) close();
    });
  })();

  /* Sticky header on scroll: transitions to solid bg, docks under announcement bar,
     writes --site-header-offset for consumers, exposes body[data-scrolled] hook. */
  (function () {
    const header = document.querySelector('[data-site-header]');
    if (!header) return;
    const overlay = header.getAttribute('data-overlay') === 'true';
    const mode = header.getAttribute('data-sticky-mode') || 'always';
    if (mode === 'off') return;

    const ann = document.querySelector('.announcement, .announcement-bar, [data-announcement-bar]');
    let lastY = window.scrollY;
    let ticking = false;

    function measure() {
      const h = header.getBoundingClientRect().height;
      document.documentElement.style.setProperty('--site-header-offset', h + 'px');
    }
    measure();
    window.addEventListener('resize', measure);

    /* Reserve the header's space in the flow, since it is fixed. Overlay
       pages deliberately sit over the hero and reserve nothing. */
    const wrapper = header.parentElement;
    function reserveSpace() {
      if (!wrapper || !wrapper.classList.contains('shopify-section')) return;
      wrapper.style.minHeight = overlay ? '' : header.offsetHeight + 'px';
    }
    reserveSpace();
    window.addEventListener('resize', reserveSpace);

    /* Dock under the announcement bar: while any of it is still on screen the
       fixed header sits below it, then pins to 0. Overlay pages are absolute
       until they scroll, and absolute means top:0 inside their own wrapper. */
    // The offer bar, when it is showing, owns the top of the window; the
    // header docks underneath it instead of sliding behind it.
    function shopBarHeight() {
      const bar = document.querySelector('[data-shop-now-bar]');
      return bar && bar.classList.contains('is-visible') ? bar.offsetHeight : 0;
    }
    function placeHeader() {
      const barH = shopBarHeight();
      const fixed = !overlay || header.classList.contains('is-scrolled');
      if (!fixed) { header.style.top = barH + 'px'; return; }
      const annH = ann ? ann.offsetHeight : 0;
      header.style.top = Math.max(0, annH - window.scrollY) + barH + 'px';
    }
    placeHeader();
    window.addEventListener('resize', placeHeader);
    window.addEventListener('shopbar:toggle', placeHeader);

    function update() {
      const y = window.scrollY;
      const scrolled = y > 8;
      header.classList.toggle('is-scrolled', scrolled);
      header.classList.toggle('is-solid', scrolled || !overlay);

      if (mode === 'scroll_up') {
        const goingUp = y < lastY;
        // Any downward scroll retires it; it only comes back on the way up.
        header.classList.toggle('is-hidden', y > 0 && !goingUp);
      }
      placeHeader();
      lastY = y;
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    update();
  })();

  /* Search panel: opens from either header's magnifier, sits under the
     header card, fetches predictive results through the Section Rendering
     API and swaps the popular terms and bestsellers for suggestions and
     products. Clearing the field puts the defaults back. */
  (function () {
    var root = document.querySelector('[data-search-overlay]');
    if (!root) return;
    var header = document.querySelector('[data-site-header]');
    var panel = root.querySelector('.search-overlay__panel');
    var input = root.querySelector('[data-search-input]');
    var cards = root.querySelector('[data-search-cards]');
    var terms = root.querySelector('[data-search-terms]');
    var asideH = root.querySelector('[data-search-aside-heading]');
    var mainH = root.querySelector('[data-search-main-heading]');
    var empty = root.querySelector('[data-search-empty]');
    var viewall = root.querySelector('[data-search-viewall]');
    if (!panel || !input || !cards || !terms) return;
    var defaults = { cards: cards.innerHTML, terms: terms.innerHTML };
    var L = root.dataset;
    var suggestUrl = L.suggestUrl || '/search/suggest';
    var searchUrl = L.searchUrl || '/search';
    var timer = null, ctrl = null, lastQ = '', opener = null;

    function place() {
      var inner = header ? Array.prototype.slice.call(header.querySelectorAll('.site-header__inner')).filter(function (el) { return el.offsetParent !== null; })[0] : null;
      var bottom = inner ? inner.getBoundingClientRect().bottom : 0;
      if (bottom < 0) bottom = 0;
      panel.style.setProperty('--so-top', Math.round(Math.max(12, bottom + 8)) + 'px');
    }
    function open(from) {
      opener = from || null;
      place();
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      void root.offsetWidth;
      root.setAttribute('data-open', 'true');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { input.focus(); }, 60);
    }
    function close() {
      if (root.hidden) return;
      root.removeAttribute('data-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      setTimeout(function () { root.hidden = true; }, 240);
      if (opener && opener.focus) opener.focus();
    }
    function reset() {
      cards.innerHTML = defaults.cards;
      terms.innerHTML = defaults.terms;
      if (asideH) asideH.textContent = L.labelPopular || '';
      if (mainH) mainH.textContent = L.labelBestsellers || '';
      if (empty) empty.hidden = true;
      if (viewall) viewall.hidden = true;
    }
    function render(q, html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var ps = doc.querySelector('[data-ps-root]');
      var n = ps ? parseInt(ps.getAttribute('data-ps-count') || '0', 10) : 0;
      var t = ps && ps.querySelector('[data-ps-terms]');
      var c = ps && ps.querySelector('[data-ps-cards]');
      if (t && t.children.length) {
        terms.innerHTML = t.innerHTML;
        if (asideH) asideH.textContent = L.labelSuggestions || '';
      } else {
        terms.innerHTML = defaults.terms;
        if (asideH) asideH.textContent = L.labelPopular || '';
      }
      if (n > 0 && c) {
        cards.innerHTML = c.innerHTML;
        if (mainH) mainH.textContent = L.labelProducts || '';
        if (empty) empty.hidden = true;
        if (viewall) { viewall.href = searchUrl + '?q=' + encodeURIComponent(q) + '&type=product'; viewall.hidden = false; }
      } else {
        cards.innerHTML = defaults.cards;
        if (mainH) mainH.textContent = L.labelBestsellers || '';
        if (empty) { empty.textContent = (L.labelEmpty || '').replace('__Q__', q); empty.hidden = false; }
        if (viewall) viewall.hidden = true;
      }
    }
    function fetchQ(q) {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      var url = suggestUrl + '?q=' + encodeURIComponent(q) + '&resources[type]=product,query&resources[limit]=4&resources[limit_scope]=each&section_id=predictive-search';
      fetch(url, { signal: ctrl.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) { if (q === lastQ) render(q, html); })
        .catch(function () {});
    }
    input.addEventListener('input', function () {
      var q = input.value.trim();
      lastQ = q;
      clearTimeout(timer);
      if (q.length < 2) { if (ctrl) ctrl.abort(); reset(); return; }
      timer = setTimeout(function () { fetchQ(q); }, 220);
    });
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var o = t.closest('[data-search-open]');
      if (o) { e.preventDefault(); open(o); return; }
      if (t.closest('[data-search-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !root.hidden) close(); });
    window.addEventListener('resize', function () { if (!root.hidden) place(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hero-slideshow]').forEach(function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
      if (slides.length < 2) return;
      var i = 0, timer = null, DELAY = 6000;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* Videos are preload="none": the file is only requested the first time
         its slide comes up, and every other slide's video is parked so the
         browser never decodes two at once. */
      function syncVideos() {
        slides.forEach(function (s, k) {
          var v = s.querySelector('[data-hero-video]');
          if (!v) return;
          if (k === i) {
            v.muted = true;
            v.defaultMuted = true;
            v.playsInline = true;
            if (v.preload !== 'auto') v.preload = 'auto';
            try { v.currentTime = 0; } catch (e) {}
            var p = v.play();
            if (p && p.catch) p.catch(function () {});
          } else if (!v.paused) {
            v.pause();
          }
        });
      }

      function show(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        syncVideos();
        dots.forEach(function (d, k) {
          d.classList.toggle('is-active', k === i);
          d.setAttribute('aria-selected', k === i ? 'true' : 'false');
          if (k !== i) d.style.setProperty('--slide-progress', '0');
        });
      }
      /* One rAF loop drives both the fill and the advance, so the bar can
         never drift out of step with the slide change. */
      var raf = null, startedAt = 0;
      function stop() {
        if (timer) { cancelAnimationFrame(timer); timer = null; }
      }
      function play() {
        if (reduce) return;
        stop();
        startedAt = performance.now();
        (function tick(now) {
          var p = Math.min(100, ((now || performance.now()) - startedAt) / DELAY * 100);
          if (dots[i]) dots[i].style.setProperty('--slide-progress', p.toFixed(2));
          if (p >= 100) { show(i + 1); startedAt = performance.now(); }
          timer = requestAnimationFrame(tick);
        })(performance.now());
      }

      dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); play(); }); });
      /* No pause on hover: the banner is not something you read, and stopping
         under the cursor made it look stuck. A hidden tab still pauses, so the
         progress ring does not race while the page is in the background. */
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : play(); });

      show(0); play();
    });
  })();
  (function () {
    /* Product spotlight: desktop card after a delay, phone bottom sheet from
       the dot. Adds to cart via /cart/add.js and lets the drawer take over. */
    function init(section) {
      var spot = section.querySelector('[data-hero-spot]');
      if (!spot || spot.__spotInit) return;
      spot.__spotInit = true;
      var phone = window.matchMedia('(max-width: 1023px)');
      var dots = section.querySelectorAll('[data-spot-dot]');
      var home = spot.parentNode;
      var delay = (parseFloat(spot.getAttribute('data-delay')) || 0) * 1000;

      // Coordinates belong to the photo, including its centred cover crop.
      // This keeps the marker on the bottle when the phone width changes.
      dots.forEach(function (dot) {
        var slide = dot.closest('[data-hero-slide]');
        var image = slide && slide.querySelector('.hero__bg-img');
        if (!image) return;
        function positionDot() {
          if (!phone.matches || !image.naturalWidth || !image.naturalHeight) return;
          var width = image.clientWidth;
          var height = image.clientHeight;
          if (!width || !height) return;
          var scale = Math.max(width / image.naturalWidth, height / image.naturalHeight);
          var artWidth = image.naturalWidth * scale;
          var artHeight = image.naturalHeight * scale;
          var x = parseFloat(dot.getAttribute('data-spot-x')) / 100;
          var y = parseFloat(dot.getAttribute('data-spot-y')) / 100;
          dot.style.setProperty('--dot-x', ((width - artWidth) / 2 + artWidth * x) + 'px');
          dot.style.setProperty('--dot-y', ((height - artHeight) / 2 + artHeight * y) + 'px');
        }
        image.addEventListener('load', positionDot);
        if (window.ResizeObserver) new ResizeObserver(positionDot).observe(slide);
        else window.addEventListener('resize', positionDot);
        if (phone.addEventListener) phone.addEventListener('change', positionDot);
        positionDot();
      });

      function place() {
        if (phone.matches) {
          if (spot.parentNode !== document.body) document.body.appendChild(spot);
          spot.classList.add('is-portaled');
        } else {
          spot.classList.remove('is-portaled', 'is-open');
          if (spot.parentNode !== home) home.appendChild(spot);
        }
      }
      function open() {
        spot.classList.add('is-open');
        dots.forEach(function (d) { d.setAttribute('aria-expanded', 'true'); });
      }
      function close() {
        spot.classList.remove('is-open');
        if (!phone.matches) spot.classList.remove('is-visible');
        dots.forEach(function (d) { d.setAttribute('aria-expanded', 'false'); });
      }
      place();
      if (phone.addEventListener) phone.addEventListener('change', place);
      setTimeout(function () { spot.classList.add('is-visible'); }, delay);
      dots.forEach(function (d) { d.addEventListener('click', open); });
      spot.querySelectorAll('[data-spot-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

      var form = spot.querySelector('[data-spot-form]');
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.hero-spot__cta');
        if (!btn || btn.disabled) return;
        btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (res) {
            if (!res.ok) throw new Error('cart/add ' + res.status);
            btn.classList.add('is-added');
            document.dispatchEvent(new CustomEvent('cart:item-added'));
            if (phone.matches) setTimeout(close, 500);
            setTimeout(function () { btn.classList.remove('is-added'); btn.disabled = false; }, 1800);
          })
          .catch(function (err) { console.warn(err); btn.disabled = false; form.submit(); });
      });
    }
    function boot() { document.querySelectorAll('[data-hero]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function () {
    document.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-mc-qty]');
      if (!btn) return;
      var wrap = btn.closest('.main-cart__qty'); var input = wrap && wrap.querySelector('input');
      if (!input) return;
      var v = parseInt(input.value, 10) || 0;
      input.value = Math.max(0, v + (btn.dataset.mcQty === 'inc' ? 1 : -1));
      var form = btn.closest('form');
      if (form && form.requestSubmit) form.requestSubmit(form.querySelector('[name=update]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mc-toolbar]').forEach(function (bar) {
      var section = bar.closest('.main-collection') || document;
      var grid = section.querySelector('.main-collection__grid');

      /* Sort reloads with the chosen sort_by, keeping any other params. */
      var sort = bar.querySelector('[data-mc-sort]');
      if (sort) {
        var valueEl = bar.querySelector('[data-mc-sort-value]');
        function paint() {
          var o = sort.options[sort.selectedIndex];
          if (valueEl) valueEl.textContent = o ? o.text : '';
        }
        paint();
        sort.addEventListener('change', paint);

        sort.addEventListener('change', function () {
          var u = new URL(window.location.href);
          u.searchParams.set('sort_by', sort.value);
          u.searchParams.delete('page');
          window.location.href = u.toString();
        });
      }

      /* Availability is filtered in the page rather than through a URL param:
         the storefront filter only exists when filters are configured for the
         collection, and this works either way. It covers the current page of
         results, which is what the shopper is looking at. */
      var stock = bar.querySelector('[data-mc-instock]');
      if (stock && grid) {
        stock.addEventListener('change', function () {
          grid.querySelectorAll('.product-card').forEach(function (c) {
            var sold = c.dataset.available === 'false';
            c.style.display = (stock.checked && sold) ? 'none' : '';
          });
        });
      }

      /* Column count, remembered per visitor. */
      var btns = Array.prototype.slice.call(bar.querySelectorAll('[data-mc-cols]'));
      function setCols(n, save) {
        if (!grid) return;
        grid.style.setProperty('--mc-cols', n);
        grid.style.setProperty('--mc-col-gap', String(n) === '5' ? '14px' : '24px');
        btns.forEach(function (b) { b.classList.toggle('is-active', b.dataset.mcCols === String(n)); });
        if (save) { try { localStorage.setItem('clab-mc-cols', n); } catch (e) {} }
      }
      btns.forEach(function (b) {
        b.addEventListener('click', function () { setCols(b.dataset.mcCols, true); });
      });
      var saved;
      try { saved = localStorage.getItem('clab-mc-cols'); } catch (e) {}
      if (saved === '4' || saved === '5') setCols(saved, false);
    });
  })();

  (function () {
    /* Mirrors the homepage tab strip: the pill parks on the active tab and
       follows the pointer. These tabs are links rather than in-page tabs, so
       it returns to the active one on leave instead of staying put. */
    document.querySelectorAll('[data-mc-tabs]').forEach(function (strip) {
      var pill = strip.querySelector('[data-mc-pill]');
      var tabs = Array.prototype.slice.call(strip.querySelectorAll('.main-collection__tab'));
      if (!pill || !tabs.length) return;
      function move(el) {
        if (!el) return;
        pill.style.setProperty('--pill-x', el.offsetLeft + 'px');
        pill.style.setProperty('--pill-w', el.offsetWidth + 'px');
        pill.classList.add('is-ready');
      }
      function home() { move(strip.querySelector('.main-collection__tab.is-active') || tabs[0]); }
      tabs.forEach(function (t) { t.addEventListener('mouseenter', function () { move(t); }); });
      strip.addEventListener('mouseleave', home);
      window.addEventListener('resize', home);
      home();

      /* Curated tabs switch panels in place; the hash keeps the tab shareable. */
      var section = strip.closest('.main-collection') || document;
      var panels = section.querySelectorAll('[data-mc-panel]');
      function show(slug) {
        var found = false;
        panels.forEach(function (p) { var on = p.getAttribute('data-mc-panel') === slug; p.hidden = !on; if (on) found = true; });
        if (!found) return;
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-mc-panel-tab') === slug;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        home();
      }
      tabs.forEach(function (t) {
        var slug = t.getAttribute('data-mc-panel-tab');
        if (!slug) return;
        t.addEventListener('click', function (e) {
          e.preventDefault();
          show(slug);
          if (history.replaceState) history.replaceState(null, '', '#' + slug);
        });
      });
      var initial = location.hash.replace('#', '');
      if (initial && section.querySelector('[data-mc-panel="' + initial + '"]')) show(initial);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-main-product]').forEach((root) => {
      const variantsRaw = root.querySelector('[data-product-json]');
      const variants = variantsRaw ? JSON.parse(variantsRaw.textContent || '[]') : [];
      const variantInput = root.querySelector('[data-variant-id]');
      const submitBtn = root.querySelector('[data-add-button]');
      const submitLabel = root.querySelector('[data-add-label]');
      const submitPill = root.querySelector('[data-add-pill]');
      const form = root.querySelector('[data-product-form]');

      const solutionCards = root.querySelectorAll('[data-solution-card]');
      const baseVariantId = variantInput ? variantInput.value : '';

      // Same format as the money filter in the visitor's currency ("1.234,56€",
      // "$1,234.56"...): the section prints 12345 with it and this copies
      // its symbol, separators and decimals, whatever the browser's locale.
      const moneyShape = (() => {
        const m = (root.dataset.moneySample || '').match(/^(.*?)12(\D?)345(?:(\D)(0+))?(.*)$/);
        return m ? { pre: m[1], thou: m[2], dec: m[3] || '', places: m[4] ? m[4].length : 0, post: m[5] }
          : { pre: '', thou: '.', dec: ',', places: 2, post: '€' };
      })();
      function moneyFormat(cents) {
        const s = moneyShape;
        const [int, frac] = (cents / 100).toFixed(s.places).split('.');
        return s.pre + int.replace(/\B(?=(\d{3})+(?!\d))/g, s.thou) + (s.places ? s.dec + frac : '') + s.post;
      }

      function selectSolution(card) {
        if (!card) return;
        solutionCards.forEach((c) => c.classList.toggle('is-selected', c === card));
        // Show the saving line belonging to the chosen card, if it has one.
        root.querySelectorAll('[data-saving-for]').forEach((n) => {
          n.hidden = n.dataset.savingFor !== card.dataset.solutionId;
        });
        const vid = card.dataset.variantId;
        const price = parseInt(card.dataset.price, 10);
        // Several rows can point at the same product (1, 2 or 4 boxes), so the
        // row also sets how many units go in and the pill shows their total.
        const qty = Math.max(parseInt(card.dataset.quantity, 10) || 1, 1);
        const qtyInput = root.querySelector('[data-solution-qty]');
        if (qtyInput) qtyInput.value = qty;
        // Card with a configured product → swap the form's variant id.
        // Card without a product picker → keep the main product's variant so the form is still addable.
        if (variantInput) variantInput.value = vid || baseVariantId;
        // Pack total when the card carries one (pack discount included).
        const total = parseInt(card.dataset.total, 10);
        if (submitPill && !isNaN(total)) submitPill.textContent = moneyFormat(total);
        else if (submitPill && !isNaN(price)) submitPill.textContent = moneyFormat(price * qty);
        // The pack's cart line property (Kaching deal); none, no property.
        const propsInput = root.querySelector('[data-tier-props]');
        if (propsInput) {
          propsInput.value = card.dataset.lineProps || '';
          propsInput.disabled = !propsInput.value;
        }
        const giftInput = root.querySelector('[data-tier-gift]');
        if (giftInput) {
          giftInput.value = card.dataset.packGift || '';
          giftInput.disabled = !giftInput.value;
        }
        // The free unit's variant: the drawer adds one per full pack.
        const freeInput = root.querySelector('[data-tier-free]');
        if (freeInput) {
          freeInput.value = card.dataset.packGift && card.dataset.freeVariant ? card.dataset.freeVariant : '';
          freeInput.disabled = !freeInput.value;
        }
        // The offer name the cart shows on the pack line (e.g. Oferta 3x2).
        const labelInput = root.querySelector('[data-tier-label]');
        if (labelInput) {
          labelInput.value = card.dataset.packLabel || '';
          labelInput.disabled = !labelInput.value;
        }
      }

      solutionCards.forEach((c) => {
        c.addEventListener('click', () => selectSolution(c));
      });

      // Initialise: pick the one marked selected_default, or first
      const initialSelected = [...solutionCards].find((c) => c.classList.contains('is-selected')) || solutionCards[0];
      if (initialSelected) selectSolution(initialSelected);

      // Quantity box (one-unit version): writes the hidden quantity field and
      // shows the line total in the button, formatted like the theme's money.
      const qtyBox = root.querySelector('[data-mp-qty]');
      if (qtyBox) {
        const qtyField = qtyBox.querySelector('[data-mp-qty-input]');
        const hiddenQty = root.querySelector('[data-solution-qty]');
        const unitPrice = parseInt(qtyBox.dataset.unitPrice, 10);
        const setQty = (n) => {
          n = Math.max(1, Math.min(99, parseInt(n, 10) || 1));
          qtyField.value = n;
          if (hiddenQty) hiddenQty.value = n;
          if (submitPill && !isNaN(unitPrice)) submitPill.textContent = moneyFormat(unitPrice * n);
        };
        qtyBox.querySelector('[data-mp-qty-minus]').addEventListener('click', () => setQty(qtyField.value - 1));
        qtyBox.querySelector('[data-mp-qty-plus]').addEventListener('click', () => setQty(parseInt(qtyField.value, 10) + 1));
        qtyField.addEventListener('change', () => setQty(qtyField.value));
        setQty(1);
      }

      // Stock note "[N] vendidos en la última hora": N is this hour's average
      // (Madrid time) from the section setting, so cached pages stay current.
      root.querySelectorAll('[data-stock-hourly]').forEach((note) => {
        const hourly = note.dataset.stockHourly.split(',').map(Number);
        let hour = new Date().getHours();
        try { hour = Number(new Intl.DateTimeFormat('es-ES', { hour: 'numeric', hourCycle: 'h23', timeZone: 'Europe/Madrid' }).format(new Date())); } catch (e) { /* browser clock */ }
        const n = Math.max(1, Math.round(hourly[hour] || 0));
        note.textContent = note.dataset.stockTemplate.replace('[N]', n);
      });

      // Add button: the rolling copy follows the live label and price, and the
      // price steps aside while the label reads a status (Añadiendo…, Añadido ✓).
      if (submitBtn && submitLabel) {
        const labelCopy = submitBtn.querySelector('[data-add-label-copy]');
        const pillCopy = submitBtn.querySelector('[data-add-pill-copy]');
        const baseLabel = submitLabel.textContent;
        const syncButton = () => {
          if (labelCopy) labelCopy.textContent = submitLabel.textContent;
          if (submitPill && pillCopy) pillCopy.textContent = submitPill.textContent;
          submitBtn.classList.toggle('is-status', submitLabel.textContent !== baseLabel);
        };
        const buttonObserver = new MutationObserver(syncButton);
        buttonObserver.observe(submitLabel, { childList: true, characterData: true, subtree: true });
        if (submitPill) buttonObserver.observe(submitPill, { childList: true, characterData: true, subtree: true });
        syncButton();
      }

      // ─── Bundle builder controller ───
      const bundleRoot = root.querySelector('[data-bundle]');
      let bundleFlavors = null;
      let bundleLoop = null;
      let bundleSubscribe = null;
      let resetBundle = null;
      let loopBoxes = [];
      let loopTiers = [];
      // Largest entry whose threshold the unit count reaches, or null.
      const reachedBy = (list, units, field) => {
        let hit = null;
        list.forEach((x) => { if (units >= x[field]) hit = x; });
        return hit;
      };
      if (bundleRoot) {
        const loopEl = bundleRoot.querySelector('[data-loop-config]');
        if (loopEl) {
          try { bundleLoop = JSON.parse(loopEl.textContent); } catch (err) { bundleLoop = null; }
        }
        bundleSubscribe = bundleRoot.querySelector('[data-autodelivery-toggle]');
        const tiers = [...bundleRoot.querySelectorAll('[data-tier]')]
          .map((el) => ({
            el,
            count: parseInt(el.dataset.tierCount, 10) || 0,
            each: parseInt(el.dataset.tierEach, 10) || 0,
            discountType: el.dataset.tierDiscountType || '',
            discountValue: parseFloat(el.dataset.tierDiscountValue) || 0
          }))
          .sort((a, b) => a.count - b.count);
        // Total after the tier's Kaching discount — same math as Kaching's
        // widget: percentage/amount on the full total, "specific" = fixed
        // price for the bar quantity, scaled per unit beyond it.
        const discountedTotal = (fullCents, units, tier) => {
          if (!tier || !units) return fullCents;
          if (tier.discountType === 'percentage') return Math.ceil(fullCents * (100 - tier.discountValue) / 100);
          if (tier.discountType === 'amount') return Math.max(0, fullCents - Math.round(tier.discountValue * 100) * units);
          if (tier.discountType === 'specific' && tier.count > 0) {
            let price = tier.discountValue * 100;
            if (units > tier.count) price = Math.ceil(price / tier.count * units);
            return Math.min(fullCents, price);
          }
          return fullCents;
        };
        // Loop box sizes and discount tiers. Start from the section settings so
        // the first paint has a price, then swap in Loop's live config.
        if (bundleLoop) {
          if (bundleLoop.boxSizeId) loopBoxes = [{ id: bundleLoop.boxSizeId, size: bundleLoop.minQty || 0 }];
          if (bundleLoop.discountCode) loopTiers = [{ code: bundleLoop.discountCode, value: bundleLoop.discountValue || 0, minQty: bundleLoop.minQty || 0 }];
        }
        // Loop pricing: the selling plan discounts every line, then the code of
        // the tier the boxed units reach takes its fixed amount off. Units past
        // the biggest full box stay at their base price.
        const loopTotal = (fullCents, units) => {
          let cents = fullCents;
          if (bundleSubscribe && bundleSubscribe.checked && bundleLoop.planPercent) {
            cents = Math.round(cents * (100 - bundleLoop.planPercent) / 100);
          }
          const box = reachedBy(loopBoxes, units, 'size');
          const tier = box ? reachedBy(loopTiers, box.size, 'minQty') : null;
          if (tier) cents = Math.max(0, cents - Math.round(tier.value * 100));
          return cents;
        };
        const fill = bundleRoot.querySelector('[data-tiers-fill]');
        const flavors = [...bundleRoot.querySelectorAll('[data-flavor]')];
        bundleFlavors = flavors;
        const addBaseLabel = submitLabel ? submitLabel.textContent : ((window.themeI18n || {}).add_to_cart || 'Add to Cart');

        const i18n = window.themeI18n || {};
        const phoneMQ = window.matchMedia('(max-width: 1023px)');
        const slotsEl = bundleRoot.querySelector('[data-bundle-slots]');
        const slots = slotsEl ? [...slotsEl.querySelectorAll('[data-slot]')] : [];
        const slotsCount = slotsEl ? slotsEl.querySelector('[data-slots-count]') : null;
        const slotsMax = slotsEl ? (parseInt(slotsEl.dataset.slotsMax, 10) || 0) : 0;
        const totalTubes = () => flavors.reduce((s, f) => s + (parseInt(f.dataset.qty, 10) || 0), 0);
        const activeIndex = (total) => {
          let idx = -1;
          tiers.forEach((t, i) => { if (total >= t.count) idx = i; });
          return idx;
        };

        function renderBundle() {
          const total = totalTubes();
          const idx = activeIndex(total);
          tiers.forEach((t, i) => {
            t.el.classList.toggle('is-reached', idx >= 0 && i <= idx);
            t.el.classList.toggle('is-active', i === idx);
          });
          if (fill && tiers.length > 1) {
            const span = 100 - 100 / tiers.length;
            const frac = idx > 0 ? idx / (tiers.length - 1) : 0;
            fill.style.width = (frac * span) + '%';
          }
          const tier = idx >= 0 ? tiers[idx] : tiers[0];
          let totalCents;
          if (bundleLoop) {
            const fullCents = flavors.reduce((s, f) => s + (parseInt(f.dataset.qty, 10) || 0) * (parseInt(f.dataset.price, 10) || 0), 0);
            totalCents = loopTotal(fullCents, total);
          } else if (tier && tier.discountType) {
            const fullCents = flavors.reduce((s, f) => s + (parseInt(f.dataset.qty, 10) || 0) * (parseInt(f.dataset.price, 10) || 0), 0);
            totalCents = discountedTotal(fullCents, total, tier);
          } else {
            totalCents = total * (tier ? tier.each : 0);
          }
          if (submitPill) submitPill.textContent = moneyFormat(totalCents);
          if (submitBtn) submitBtn.disabled = total === 0;
          /* Phones: an empty pack says how many to add instead of a greyed
             "add to cart"; desktop keeps its label. */
          const emptyLabel = (phoneMQ.matches && slotsMax > 0 && i18n.bundle_add_more)
            ? i18n.bundle_add_more.replace('[n]', slotsMax) : addBaseLabel;
          if (submitLabel && total === 0) submitLabel.textContent = emptyLabel;
          else if (submitLabel && submitBtn && submitBtn.hasAttribute('data-bundle-empty')) submitLabel.textContent = addBaseLabel;
          if (submitBtn) submitBtn.toggleAttribute('data-bundle-empty', total === 0);
          if (slots.length) {
            const picked = [];
            flavors.forEach((f) => {
              const q = parseInt(f.dataset.qty, 10) || 0;
              const em = f.querySelector('.main-product__flavor-emoji');
              for (let k = 0; k < q; k++) picked.push(em ? em.textContent.trim() : '');
            });
            slots.forEach((s, i) => {
              s.classList.toggle('is-filled', i < total);
              const em = s.querySelector('[data-slot-emoji]');
              if (em) em.textContent = picked[i] || '';
            });
            if (slotsCount) slotsCount.textContent = Math.min(total, slotsMax) + '/' + slotsMax;
          }
          bundleRoot.dataset.empty = total === 0 ? '1' : '';
          bundleRoot.dataset.from = tiers.length ? moneyFormat(tiers[0].each) : '';
          root.dispatchEvent(new CustomEvent('clab:bundle-render'));
          flavors.forEach((f) => {
            const q = parseInt(f.dataset.qty, 10) || 0;
            f.classList.toggle('is-added', q > 0);
            const qEl = f.querySelector('[data-flavor-qty]');
            if (qEl) qEl.textContent = q;
          });
        }

        flavors.forEach((f) => {
          const setQty = (q) => { f.dataset.qty = Math.max(0, q); renderBundle(); };
          const add = f.querySelector('[data-flavor-add]');
          const minus = f.querySelector('[data-flavor-minus]');
          const plus = f.querySelector('[data-flavor-plus]');
          if (add) add.addEventListener('click', () => setQty(1));
          if (plus) plus.addEventListener('click', () => setQty((parseInt(f.dataset.qty, 10) || 0) + 1));
          if (minus) minus.addEventListener('click', () => setQty((parseInt(f.dataset.qty, 10) || 0) - 1));
        });
        if (bundleSubscribe) bundleSubscribe.addEventListener('change', renderBundle);
        if (phoneMQ.addEventListener) phoneMQ.addEventListener('change', renderBundle);
        resetBundle = () => {
          flavors.forEach((f) => { f.dataset.qty = 0; });
          renderBundle();
        };
        renderBundle();
        // The helper is deferred, so wait for the page before asking Loop.
        if (bundleLoop) {
          const loadLive = () => {
            if (!window.clabLoopBundle) return;
            window.clabLoopBundle.load(bundleLoop).then((live) => {
              if (live.boxes.length) loopBoxes = live.boxes;
              if (live.tiers.length) loopTiers = live.tiers;
              renderBundle();
            });
          };
          if (document.readyState === 'complete') loadLive();
          else window.addEventListener('load', loadLive);
        }
      }

      // Gallery thumbnails ↔ main scroll sync (mobile)
      const main = root.querySelector('[data-gallery-main]');
      // The endorsement sticker belongs to the first shot only: it fades out
      // as soon as the gallery moves a quarter of a tile away from it.
      if (main) {
        main.addEventListener('scroll', () => {
          const sticker = root.querySelector('.main-product__sticker');
          const first = main.querySelector('[data-tile-index]');
          if (!sticker || !first) return;
          sticker.classList.toggle('is-away', main.scrollLeft > first.getBoundingClientRect().width * 0.25);
        }, { passive: true });
      }
      const thumbs = root.querySelectorAll('[data-thumb-index]');
      const tiles = root.querySelectorAll('[data-tile-index]');
      if (main && thumbs.length && tiles.length) {
        thumbs.forEach((t) => {
          t.addEventListener('click', () => {
            const idx = parseInt(t.dataset.thumbIndex, 10);
            const tile = tiles[idx];
            if (tile) tile.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
            thumbs.forEach((x) => x.classList.toggle('is-active', x === t));
          });
        });
        let curIdx = 0;
        main.addEventListener('scroll', () => {
          const scrollLeft = main.scrollLeft;
          const tileW = tiles[0] ? tiles[0].getBoundingClientRect().width + 8 : 0;
          if (!tileW) return;
          const idx = Math.round(scrollLeft / tileW);
          curIdx = idx;
          thumbs.forEach((t, i) => t.classList.toggle('is-active', i === idx));
        }, { passive: true });

        // Hover arrows step one tile; the scroll handler keeps the thumbs in sync.
        const step = (dir) => {
          const tileW = tiles[0] ? tiles[0].getBoundingClientRect().width + 8 : 0;
          if (tileW) main.scrollBy({ left: dir * tileW, behavior: 'smooth' });
        };
        const prevBtn = root.querySelector('[data-gallery-prev]');
        const nextBtn = root.querySelector('[data-gallery-next]');
        if (prevBtn) prevBtn.addEventListener('click', () => step(-1));
        if (nextBtn) nextBtn.addEventListener('click', () => step(1));

        const thumbsEl = root.querySelector('[data-gallery-thumbs]');
        const thumbsNext = root.querySelector('[data-thumbs-next]');
        if (thumbsEl && thumbsNext) {
          const syncThumbsNext = () => {
            const more = thumbsEl.scrollWidth - thumbsEl.clientWidth - thumbsEl.scrollLeft;
            thumbsNext.hidden = more < 4;
          };
          thumbsNext.addEventListener('click', () => {
            const t = thumbsEl.querySelector('.main-product__thumb');
            const step = t ? (t.getBoundingClientRect().width + 6) * 3 : 300;
            thumbsEl.scrollBy({ left: step, behavior: 'smooth' });
          });
          thumbsEl.addEventListener('scroll', syncThumbsNext, { passive: true });
          window.addEventListener('resize', syncThumbsNext);
          syncThumbsNext();
        }

        const stickerClose = root.querySelector('[data-sticker-close]');
        if (stickerClose) {
          stickerClose.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const sticker = stickerClose.closest('.main-product__sticker');
            if (sticker) sticker.remove();
          });
        }

        // Magnifier: the image on show, full size, over a dimmed page.
        const zoomBtn = root.querySelector('[data-gallery-zoom]');
        if (zoomBtn) {
          zoomBtn.addEventListener('click', () => {
            const img = tiles[curIdx] && tiles[curIdx].querySelector('img');
            if (!img) return;
            const box = document.createElement('div');
            box.className = 'main-product__lightbox';
            const big = document.createElement('img');
            big.src = (img.currentSrc || img.src).replace(/([?&]width=)\d+/, '$11600');
            big.alt = img.alt || '';
            box.appendChild(big);
            const close = () => {
              box.remove();
              document.removeEventListener('keydown', onKey);
            };
            const onKey = (e) => { if (e.key === 'Escape') close(); };
            box.addEventListener('click', close);
            document.addEventListener('keydown', onKey);
            document.body.appendChild(box);
          });
        }
      }

      // Intercept submit → AJAX add → open cart drawer
      if (form) {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          if (submitBtn) submitBtn.disabled = true;
          const originalLabel = submitLabel ? submitLabel.textContent : '';
          if (submitLabel) submitLabel.textContent = (window.themeI18n || {}).adding || 'Adding…';
          try {
            let res;
            if (bundleFlavors) {
              // Bundle: the biggest Loop box the selection fills goes in as one
              // Loop transaction; units past it are added as plain lines and
              // stay at their base price, which is how Loop's tiers price them.
              const picked = bundleFlavors
                .map((f) => ({ id: parseInt(f.dataset.variantId, 10), quantity: parseInt(f.dataset.qty, 10) || 0 }))
                .filter((it) => it.id && it.quantity > 0);
              if (!picked.length) {
                if (submitLabel) submitLabel.textContent = originalLabel || (window.themeI18n || {}).add_to_cart || 'Add to Cart';
                if (submitBtn) submitBtn.disabled = false;
                return;
              }
              // Everything is sold on subscription: the box always goes on the
              // Loop plan when there is one; the toggle only matters without it.
              const subscribed = !!(bundleLoop && bundleLoop.sellingPlanId) || !!(bundleSubscribe && bundleSubscribe.checked);
              const plan = subscribed && bundleLoop && bundleLoop.sellingPlanId ? parseInt(bundleLoop.sellingPlanId, 10) : null;
              const withPlan = (it) => (plan ? Object.assign(it, { selling_plan: plan }) : it);
              const units = picked.reduce((s, it) => s + it.quantity, 0);
              const box = bundleLoop ? reachedBy(loopBoxes, units, 'size') : null;
              let items = picked.map((it) => withPlan({ id: it.id, quantity: it.quantity }));
              let boxed = false;
              if (box) {
                // Fill the box flavor by flavor, in the order they are listed.
                let room = box.size;
                const inBox = [];
                const loose = [];
                picked.forEach((it) => {
                  const take = Math.min(room, it.quantity);
                  room -= take;
                  if (take) inBox.push({ id: it.id, quantity: take });
                  if (it.quantity > take) loose.push({ id: it.id, quantity: it.quantity - take });
                });
                const tier = reachedBy(loopTiers, box.size, 'minQty');
                try {
                  const txnRes = await fetch(bundleLoop.api + '/bundle/' + bundleLoop.bundleId + '/transaction?myshopifyDomain=' + encodeURIComponent(bundleLoop.shop), {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                      boxSizeId: box.id,
                      sellingPlanShopifyId: plan,
                      quantity: 1,
                      productVariants: inBox.map((it) => ({ shopifyId: it.id, quantity: it.quantity }))
                    })
                  });
                  const txn = await txnRes.json();
                  const txnId = txn && txn.data && txn.data.txnId;
                  if (txnId) {
                    // _bundleId keeps the box together for Loop. The rest is
                    // ours: _bundleName titles the drawer card, _bundleCfg lets
                    // the drawer rebuild this exact box on a subscription (a
                    // plan change needs a fresh Loop transaction), and
                    // _bundlePct/_bundleOff price that offer in Liquid.
                    const props = {
                      _bundleId: txnId,
                      _bundleCfg: JSON.stringify({
                        api: bundleLoop.api,
                        shop: bundleLoop.shop,
                        bundleId: bundleLoop.bundleId,
                        boxSizeId: box.id,
                        sellingPlanId: bundleLoop.sellingPlanId,
                        discountCode: tier ? tier.code : bundleLoop.discountCode,
                        discountValue: tier ? tier.value : bundleLoop.discountValue,
                        planPercent: bundleLoop.planPercent,
                        minQty: box.size
                      }),
                      _bundlePct: String(bundleLoop.planPercent || 0),
                      _bundleOff: String(tier ? tier.value : 0)
                    };
                    if (bundleLoop.name) props._bundleName = bundleLoop.name;
                    items = inBox
                      .map((it) => withPlan({ id: it.id, quantity: it.quantity, properties: Object.assign({}, props) }))
                      .concat(loose.map((it) => withPlan({ id: it.id, quantity: it.quantity })));
                    boxed = true;
                  }
                } catch (err) {
                  console.warn('loop bundle transaction failed', err);
                }
              }
              res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ items })
              });
              // The tier is decided by every box in the cart, not just this
              // one: a second pack of 3 has to move the cart onto the 6 code.
              if (res.ok && boxed && window.clabLoopBundle) {
                try {
                  await window.clabLoopBundle.syncDiscount(bundleLoop);
                } catch (err) {
                  console.warn('loop discount failed', err);
                }
              }
            } else {
              const fd = new FormData(form);
              // make sure id is present
              if (!fd.get('id') && variantInput) fd.set('id', variantInput.value);
              res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { Accept: 'application/json' },
                credentials: 'same-origin',
                body: fd
              });
            }
            if (!res.ok) {
              const txt = await res.text();
              console.warn('cart/add failed', res.status, txt);
              if (submitLabel) submitLabel.textContent = (window.themeI18n || {}).try_again || 'Try again';
              return;
            }
            const chosenTier = root.querySelector('[data-solution-card].is-selected');
            // A pack priced by a discount code: the code goes on the cart right
            // after the add, before the drawer refreshes.
            const tierCode = chosenTier && chosenTier.dataset.discountCode;
            if (tierCode) {
              try {
                await fetch('/cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                  credentials: 'same-origin',
                  body: JSON.stringify({ discount: tierCode })
                });
              } catch (err) { console.warn('pack code failed', err); }
            }
            // notify cart drawer
            document.dispatchEvent(new CustomEvent('cart:item-added'));
            if (submitLabel) submitLabel.textContent = (window.themeI18n || {}).added || 'Added ✓';
            // The pack is in the cart now: leaving the flavors selected made the
            // next pack add these ones all over again.
            if (bundleFlavors && typeof resetBundle === 'function') resetBundle();
            setTimeout(() => { if (submitLabel) submitLabel.textContent = originalLabel || (window.themeI18n || {}).add_to_cart || 'Add to Cart'; }, 1400);
          } catch (err) {
            console.warn('cart/add error', err);
            if (submitLabel) submitLabel.textContent = (window.themeI18n || {}).try_again || 'Try again';
          } finally {
            if (submitBtn) submitBtn.disabled = false;
          }
        });
      }
    });
  })();

  /* Sticky ATC bar — reveal when the primary Add to Cart button scrolls out
     of the viewport; click delegates to the real submit button so all form
     state (variant, quantity, subscribe toggle) is honoured. */
  (function () {
    document.querySelectorAll('.main-product').forEach((root) => {
      const bar = root.querySelector('[data-sticky-atc]');
      const primary = root.querySelector('[data-add-button]');
      const barBtn = root.querySelector('[data-sticky-atc-btn]');
      const barPrice = root.querySelector('[data-sticky-atc-price]');
      const pill = root.querySelector('[data-add-pill]');
      if (!bar || !primary || !barBtn) return;

      /* Only render on desktop widths for now — mobile has its own tap area. */
      bar.hidden = false;

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            bar.classList.remove('is-visible');
          } else {
            bar.classList.add('is-visible');
          }
        });
      }, { threshold: 0 });
      io.observe(root);

      /* iOS 26 Safari: after the keyboard closes, visualViewport.offsetTop can
         stay above 0 and every bottom-fixed element floats mid-screen. Push the
         card down by the gap between the visible bottom and the layout one;
         0 when they match, while typing or when the page is pinch-zoomed. */
      const vv = window.visualViewport;
      if (vv) {
        const glue = () => {
          const typing = document.activeElement && document.activeElement.matches('input, textarea, select, [contenteditable]');
          let gap = Math.round(vv.offsetTop + vv.height - window.innerHeight);
          if (typing || Math.abs(vv.scale - 1) > 0.01 || gap < 2) gap = 0;
          bar.style.setProperty('--sticky-vv', gap + 'px');
        };
        vv.addEventListener('resize', glue);
        vv.addEventListener('scroll', glue);
        window.addEventListener('scroll', glue, { passive: true });
        glue();
      }

      /* Mirror the pill price so subscribe/qty updates flow into the sticky bar. */
      /* Phones, pack with nothing chosen yet: "from" price and a button
         that takes the visitor to the flavour list instead of a 0,00 total
         and an add-to-cart that cannot add. */
      const bundleEl = root.querySelector('[data-bundle]');
      const barPhoneMQ = window.matchMedia('(max-width: 1023px)');
      const barI18n = window.themeI18n || {};
      const barLines = barBtn.querySelectorAll('.clab-roll__line');
      const barBaseLabel = barLines.length ? barLines[0].textContent : '';
      const bundlePending = () => !!(bundleEl && bundleEl.dataset.empty === '1' && barPhoneMQ.matches);
      const syncBar = () => {
        if (!bundleEl) return;
        const pending = bundlePending();
        if (barPrice) {
          if (pending && bundleEl.dataset.from && barI18n.from_price) barPrice.textContent = barI18n.from_price.replace('[price]', bundleEl.dataset.from);
          else if (pill) barPrice.textContent = pill.textContent.trim();
        }
        const label = pending && barI18n.choose ? barI18n.choose : barBaseLabel;
        barLines.forEach((l) => { if (l.textContent !== label) l.textContent = label; });
      };
      root.addEventListener('clab:bundle-render', syncBar);
      if (barPhoneMQ.addEventListener) barPhoneMQ.addEventListener('change', syncBar);
      syncBar();

      if (pill && barPrice) {
        const mo = new MutationObserver(() => {
          barPrice.textContent = pill.textContent.trim();
          syncBar();
        });
        mo.observe(pill, { childList: true, characterData: true, subtree: true });
      }

      const planSel = root.querySelector('[data-sticky-plan]');
      if (planSel) {
        const radios = root.querySelectorAll('input[name="selling_plan"]');
        planSel.addEventListener('change', () => {
          radios.forEach((r) => {
            if (r.value === planSel.value) {
              r.checked = true;
              r.dispatchEvent(new Event('change', { bubbles: true }));
            }
          });
        });
        radios.forEach((r) => r.addEventListener('change', () => {
          if (r.checked) planSel.value = r.value;
        }));
      }

      barBtn.addEventListener('click', () => {
        if (bundlePending()) {
          bundleEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        primary.click();
        primary.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  })();
  (function () {
    const root = document.querySelector('[data-da]');
    if (!root) return;
    const tabs = root.querySelectorAll('[data-da-tab]');
    const panels = root.querySelectorAll('[data-da-panel]');

    function select(id) {
      tabs.forEach(function (t) {
        const on = t.dataset.daTab === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.daPanel === id); });
    }
    tabs.forEach(function (t) { t.addEventListener('click', function () { select(t.dataset.daTab); }); });

    // The roster scrolls sideways; each edge fades while doctors are hidden
    // past it. A mouse can drag it (touch and trackpads scroll natively).
    (function () {
      const strip = root.querySelector('[data-da-doctors]');
      if (!strip) return;
      function sync() {
        const max = strip.scrollWidth - strip.clientWidth;
        strip.classList.toggle('is-fade-l', max > 1 && strip.scrollLeft > 1);
        strip.classList.toggle('is-fade-r', max > 1 && strip.scrollLeft < max - 1);
      }
      let down = false, startX = 0, startLeft = 0;
      strip.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true;
        startX = e.clientX;
        startLeft = strip.scrollLeft;
        strip.classList.add('is-dragging');
        strip.setPointerCapture(e.pointerId);
      });
      strip.addEventListener('pointermove', function (e) {
        if (!down) return;
        strip.scrollLeft = startLeft - (e.clientX - startX);
      });
      function end() { down = false; strip.classList.remove('is-dragging'); }
      strip.addEventListener('pointerup', end);
      strip.addEventListener('pointercancel', end);
      strip.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      window.addEventListener('load', sync);
      sync();
    })();

    // Arrows show only while their strip has somewhere left to go.
    function wire(scroller, prev, next) {
      if (!scroller || !prev || !next) return;
      function sync() {
        const max = scroller.scrollWidth - scroller.clientWidth;
        prev.classList.toggle('is-shown', max > 1 && scroller.scrollLeft > 1);
        next.classList.toggle('is-shown', max > 1 && scroller.scrollLeft < max - 1);
      }
      prev.addEventListener('click', function () { scroller.scrollBy({ left: -scroller.clientWidth * 0.8, behavior: 'smooth' }); });
      next.addEventListener('click', function () { scroller.scrollBy({ left: scroller.clientWidth * 0.8, behavior: 'smooth' }); });
      scroller.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }
    wire(root.querySelector('[data-da-tabs]'), root.querySelector('[data-da-tab-prev]'), root.querySelector('[data-da-tab-next]'));
  })();

  /* Recently viewed: remember this product for the listing's tab. */
  (function () {
    var root = document.querySelector('[data-main-product]');
    var handle = root && root.getAttribute('data-rv-handle');
    if (!handle) return;
    try {
      var key = 'obsessive_recently_viewed';
      var list = JSON.parse(localStorage.getItem(key) || '[]');
      list = [handle].concat(list.filter(function (h) { return h !== handle; })).slice(0, 12);
      localStorage.setItem(key, JSON.stringify(list));
    } catch (e) {}
  })();

  /* Real results: progress bar under the row. */
  (function () {
    document.querySelectorAll('.main-product__rr').forEach(function (rr) {
      var track = rr.querySelector('.main-product__rr-track');
      var bar = rr.querySelector('[data-rr-scrollbar]');
      var thumb = bar && bar.querySelector('[data-rr-thumb]');
      if (!track || !thumb) return;
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        bar.hidden = max <= 2;
        if (bar.hidden) return;
        var barW = bar.clientWidth;
        var thumbW = Math.max(24, Math.round(barW * track.clientWidth / track.scrollWidth));
        thumb.style.width = thumbW + 'px';
        thumb.style.transform = 'translateX(' + Math.round((track.scrollLeft / max) * (barW - thumbW)) + 'px)';
      }
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () { update(); ticking = false; });
      }, { passive: true });
      window.addEventListener('resize', update);
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      update();
    });
  })();

  /* Flavour picker: hovering or focusing a dot previews its name in the label. */
  (function () {
    document.querySelectorAll('[data-fpick]').forEach(function (root) {
      const name = root.querySelector('[data-fpick-name]');
      if (!name) return;
      const reset = function () { name.textContent = name.dataset.fpickDefault; };
      root.querySelectorAll('[data-fpick-dot]').forEach(function (dot) {
        const show = function () { name.textContent = dot.dataset.fpickDot; };
        dot.addEventListener('mouseenter', show);
        dot.addEventListener('focus', show);
        dot.addEventListener('mouseleave', reset);
        dot.addEventListener('blur', reset);
      });
    });
  })();

  /* Real results: hosted videos play one at a time, in order, while the row
     is on screen; a click opens the video in a popup that is always muted. */
  (function () {
    document.querySelectorAll('.main-product__rr').forEach(function (rr) {
      const tiles = Array.prototype.slice.call(rr.querySelectorAll('[data-rr-video]'));
      const vids = tiles.map(function (t) { return t.querySelector('video'); });
      if (!tiles.length || vids.indexOf(null) !== -1) return;

      const track = rr.querySelector('.main-product__rr-track');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let current = 0;
      let inView = false;
      let popupOpen = false;
      let touchedAt = 0;

      vids.forEach(function (v) { v.muted = true; v.loop = false; });

      function play(v) {
        const p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
      function pauseAll() { vids.forEach(function (v) { v.pause(); }); }
      function canPlay() { return inView && !popupOpen && !reduceMotion; }

      // Keep the playing tile in sight, unless the shopper is swiping the row.
      function reveal(tile) {
        if (!track || Date.now() - touchedAt < 4000) return;
        const left = tile.offsetLeft - track.offsetLeft;
        if (left < track.scrollLeft || left + tile.offsetWidth > track.scrollLeft + track.clientWidth) {
          track.scrollTo({ left: left, behavior: 'smooth' });
        }
      }

      function playAt(i) {
        current = i;
        vids.forEach(function (v, j) { if (j !== i) v.pause(); });
        tiles.forEach(function (t, j) { t.classList.toggle('is-playing', j === i); });
        if (!canPlay()) return;
        try { vids[i].currentTime = 0; } catch (e) {}
        play(vids[i]);
        reveal(tiles[i]);
      }
      const next = function () { playAt((current + 1) % vids.length); };

      vids.forEach(function (v, i) {
        v.addEventListener('ended', function () { if (i === current) next(); });
        // A file that will not load must not stall the whole row.
        v.addEventListener('error', function () { if (i === current && canPlay()) next(); });
      });

      if (track) {
        ['pointerdown', 'wheel', 'touchstart'].forEach(function (ev) {
          track.addEventListener(ev, function () { touchedAt = Date.now(); }, { passive: true });
        });
      }

      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        if (canPlay()) play(vids[current]); else pauseAll();
      }, { threshold: 0.25 }).observe(rr);

      // ─── Popup ───
      const modal = rr.querySelector('[data-rr-modal]');
      if (!modal) return;
      // Out of the section so no transformed ancestor traps the fixed overlay.
      document.body.appendChild(modal);
      const frame = modal.querySelector('[data-rr-frame]');
      const closeBtn = modal.querySelector('[data-rr-close]');
      let opener = null;
      let prevOverflow = '';

      function forceMute(v) {
        v.muted = true;
        v.defaultMuted = true;
        v.volume = 0;
      }

      function open(i) {
        opener = tiles[i];
        popupOpen = true;
        pauseAll();

        const v = document.createElement('video');
        Array.prototype.forEach.call(vids[i].querySelectorAll('source'), function (s) {
          v.appendChild(s.cloneNode(true));
        });
        if (!v.children.length && vids[i].currentSrc) v.src = vids[i].currentSrc;
        if (vids[i].poster) v.poster = vids[i].poster;
        v.setAttribute('playsinline', '');
        v.setAttribute('muted', '');
        v.setAttribute('loop', '');
        v.setAttribute('disablepictureinpicture', '');
        v.setAttribute('disableremoteplayback', '');
        v.setAttribute('controlslist', 'nodownload nofullscreen noremoteplayback');
        v.controls = false;
        forceMute(v);
        // Nothing may turn the sound on: undo any attempt straight away.
        v.addEventListener('volumechange', function () {
          if (!v.muted || v.volume > 0) forceMute(v);
        });
        // Tap to pause / resume; there are no other controls.
        v.addEventListener('click', function () { if (v.paused) play(v); else v.pause(); });

        frame.innerHTML = '';
        frame.appendChild(v);
        modal.hidden = false;
        prevOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        play(v);
        if (closeBtn) closeBtn.focus();
      }

      function close() {
        if (modal.hidden) return;
        const v = frame.querySelector('video');
        if (v) v.pause();
        frame.innerHTML = '';
        modal.hidden = true;
        document.documentElement.style.overflow = prevOverflow;
        popupOpen = false;
        if (opener) opener.focus({ preventScroll: true });
        if (canPlay()) play(vids[current]);
      }

      tiles.forEach(function (t, i) {
        t.addEventListener('click', function () { open(i); });
      });
      if (closeBtn) closeBtn.addEventListener('click', close);
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    });
  })();


  /* "How it works" popup: the first gallery CTA opens the see-how section's
     video in the frosted veil (same look as the real-results popup). Tap the
     video to pause / resume; the veil, the X and Escape close it. */
  (function () {
    document.querySelectorAll('[data-vid-modal]').forEach(function (modal) {
      var section = modal.closest('.main-product') || document;
      var cta = section.querySelector('[data-video-cta="see-how"]');
      if (!cta) return;
      document.body.appendChild(modal);
      var frame = modal.querySelector('[data-vid-frame]');
      var closeBtn = modal.querySelector('[data-vid-close]');
      var prevOverflow = '';
      function close() {
        if (modal.hidden) return;
        var v = frame.querySelector('video');
        if (v) v.pause();
        frame.innerHTML = '';
        modal.hidden = true;
        document.documentElement.style.overflow = prevOverflow;
        cta.focus({ preventScroll: true });
      }
      function open(src) {
        var v = document.createElement('video');
        Array.prototype.forEach.call(src.querySelectorAll('source'), function (x) { v.appendChild(x.cloneNode(true)); });
        if (!v.children.length && src.currentSrc) v.src = src.currentSrc;
        if (src.poster) v.poster = src.poster;
        v.setAttribute('playsinline', '');
        v.setAttribute('loop', '');
        v.setAttribute('muted', '');
        v.setAttribute('disablepictureinpicture', '');
        v.muted = true;
        v.controls = false;
        v.addEventListener('loadedmetadata', function () {
          if (v.videoWidth && v.videoHeight) frame.style.setProperty('--vm-ar', v.videoWidth + ' / ' + v.videoHeight);
        });
        v.addEventListener('click', function () { if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } });
        frame.innerHTML = '';
        frame.appendChild(v);
        modal.hidden = false;
        prevOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        if (closeBtn) closeBtn.focus();
      }
      cta.addEventListener('click', function (e) {
        var src = document.querySelector('.see-how__media-video');
        if (!src) return;
        e.preventDefault();
        open(src);
      });
      if (closeBtn) closeBtn.addEventListener('click', close);
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    });
  })();

  /* Before / after popup: the second gallery CTA lifts every real-people shot
     on the page (photo + ANTES / DÍA 7 labels) into a swipeable row in the
     same frosted veil, with a dot per shot under the frame. */
  (function () {
    document.querySelectorAll('[data-ba-modal]').forEach(function (modal) {
      var section = modal.closest('.main-product') || document;
      var cta = section.querySelector('[data-video-cta="ba"]');
      if (!cta) return;
      document.body.appendChild(modal);
      var frame = modal.querySelector('[data-ba-frame]');
      var dots = modal.querySelector('[data-ba-dots]');
      var closeBtn = modal.querySelector('[data-ba-close]');
      var prevOverflow = '';
      function close() {
        if (modal.hidden) return;
        modal.hidden = true;
        document.documentElement.style.overflow = prevOverflow;
        cta.focus({ preventScroll: true });
      }
      function build() {
        var shots = document.querySelectorAll('.real-people__shot');
        if (!shots.length) return false;
        var track = document.createElement('div');
        track.className = 'main-product__ba-track';
        // One slide plus the gap between slides: the distance from one snap point to the next.
        function step() { return Math.max(1, track.clientWidth + (parseFloat(getComputedStyle(track).columnGap) || 0)); }
        dots.innerHTML = '';
        var dotEls = [];
        Array.prototype.forEach.call(shots, function (shot, i) {
          var slide = document.createElement('div');
          slide.className = 'main-product__ba-slide';
          var clone = shot.cloneNode(true);
          Array.prototype.forEach.call(clone.querySelectorAll('img'), function (im) { im.loading = 'eager'; im.sizes = '560px'; });
          slide.appendChild(clone);
          track.appendChild(slide);
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'main-product__ba-dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', (i + 1) + ' / ' + shots.length);
          d.addEventListener('click', function () { track.scrollTo({ left: step() * i, behavior: 'smooth' }); });
          dots.appendChild(d);
          dotEls.push(d);
        });
        track.addEventListener('scroll', function () {
          var i = Math.round(track.scrollLeft / step());
          dotEls.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
        }, { passive: true });
        frame.innerHTML = '';
        frame.appendChild(track);
        return true;
      }
      cta.addEventListener('click', function (e) {
        if (!build()) return;
        e.preventDefault();
        modal.hidden = false;
        prevOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        if (closeBtn) closeBtn.focus();
      });
      if (closeBtn) closeBtn.addEventListener('click', close);
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nav-drawer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-nav-drawer]').forEach((root) => {
      // The submenus wait to the right inside the main view; if anything
      // scrolls it sideways (focus, a swipe), put it back.
      root.querySelectorAll('.nav-drawer__view').forEach((v) => {
        v.addEventListener('scroll', () => { if (v.scrollLeft !== 0) v.scrollLeft = 0; }, { passive: true });
      });
      function open() {
        root.removeAttribute('hidden');
        // force reflow so transition kicks in
        void root.offsetWidth;
        root.setAttribute('data-open', 'true');
        root.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
      }
      function closeSubmenus() {
        root.querySelectorAll('[data-nav-submenu].is-open').forEach((sm) => {
          sm.classList.remove('is-open');
          sm.setAttribute('aria-hidden', 'true');
        });
      }
      function openSubmenu(i) {
        const sm = root.querySelector('[data-nav-submenu="' + i + '"]');
        if (!sm) return;
        closeSubmenus();
        sm.scrollTop = 0;
        sm.classList.add('is-open');
        sm.setAttribute('aria-hidden', 'false');
      }
      function close() {
        root.removeAttribute('data-open');
        root.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        setTimeout(() => { root.setAttribute('hidden', ''); closeSubmenus(); }, 320);
      }

      document.addEventListener('click', (e) => {
        const t = e.target;
        if (!t || !t.closest) return;
        const opener = t.closest('[data-nav-drawer-open]');
        if (opener) { e.preventDefault(); open(); return; }
        const subOpen = t.closest('[data-nav-submenu-open]');
        if (subOpen && root.contains(subOpen)) { e.preventDefault(); openSubmenu(subOpen.getAttribute('data-nav-submenu-open')); return; }
        const subClose = t.closest('[data-nav-submenu-close]');
        if (subClose && root.contains(subClose)) { e.preventDefault(); closeSubmenus(); return; }
        const closer = t.closest('[data-nav-drawer-close]');
        if (closer) { e.preventDefault(); close(); }
      });
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape' || root.getAttribute('data-open') !== 'true') return;
        // Back out one level: close an open submenu first, otherwise close the drawer.
        if (root.querySelector('[data-nav-submenu].is-open')) closeSubmenus();
        else close();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-comparison"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-pdp-comparison]').forEach(function (root) {
      var track = root.querySelector('[data-track]');
      var nav = root.querySelector('.pdp-comparison__nav');
      var dots = Array.prototype.slice.call(root.querySelectorAll('.pdp-comparison__dot'));
      if (!track) return;
      var cards = Array.prototype.slice.call(track.querySelectorAll('.pdp-comparison__card'));
      function active() {
        var max = track.scrollWidth - track.clientWidth;
        if (max <= 2) return 0;
        if (track.scrollLeft >= max - 2) return cards.length - 1;
        var best = 0, min = Infinity;
        cards.forEach(function (c, i) {
          var d = Math.abs(c.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < min) { min = d; best = i; }
        });
        return best;
      }
      function paint() {
        var i = active();
        dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
      }
      function layout() {
        if (nav) nav.classList.toggle('is-static', track.scrollWidth <= track.clientWidth + 2);
        paint();
      }
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () { paint(); ticking = false; });
      }, { passive: true });
      dots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          var c = cards[i]; if (!c) return;
          track.scrollTo({ left: c.offsetLeft - track.offsetLeft, behavior: 'smooth' });
        });
      });
      window.addEventListener('resize', layout);
      layout();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-complete-routine"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORE_KEY = 'obsessive_recently_viewed';

    document.querySelectorAll('[data-pdp-complete-routine]').forEach(function (root) {
      /* ---- progress bars: one per panel, thumb = visible share of the track ---- */
      function bindBar(panel) {
        var track = panel.querySelector('[data-track]');
        var bar = panel.querySelector('[data-scrollbar]');
        var thumb = bar && bar.querySelector('[data-thumb]');
        if (!track || !thumb) return function () {};
        function update() {
          if (panel.hidden) return;
          var max = track.scrollWidth - track.clientWidth;
          bar.hidden = max <= 2;
          if (bar.hidden) return;
          var barW = bar.clientWidth;
          var thumbW = Math.max(20, Math.round(barW * track.clientWidth / track.scrollWidth));
          thumb.style.width = thumbW + 'px';
          thumb.style.transform = 'translateX(' + Math.round((track.scrollLeft / max) * (barW - thumbW)) + 'px)';
        }
        var ticking = false;
        track.addEventListener('scroll', function () {
          if (ticking) return; ticking = true;
          requestAnimationFrame(function () { update(); ticking = false; });
        }, { passive: true });
        window.addEventListener('resize', update);
        update();
        return update;
      }
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-tab-panel]'));
      var updaters = {};
      panels.forEach(function (p) { updaters[p.dataset.tabPanel] = bindBar(p); });

      /* ---- tabs with the sliding pill, as on the home listing ---- */
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
      var pill = root.querySelector('[data-tab-pill]');
      function movePill(t) {
        if (!pill || !t) return;
        pill.style.setProperty('--pill-x', t.offsetLeft + 'px');
        pill.style.setProperty('--pill-w', t.offsetWidth + 'px');
        pill.classList.add('is-ready');
      }
      function pillToActive() { movePill(root.querySelector('[data-tab].is-active')); }
      function activate(slug) {
        tabs.forEach(function (t) {
          var on = t.dataset.tab === slug;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) { p.hidden = p.dataset.tabPanel !== slug; });
        if (updaters[slug]) updaters[slug]();
        if (slug === 'recent') loadRecent();
      }
      if (tabs.length) {
        tabs.forEach(function (t) {
          t.addEventListener('click', function () { activate(t.dataset.tab); movePill(t); });
          t.addEventListener('mouseenter', function () { movePill(t); });
        });
        var bar = root.querySelector('.pdp-complete-routine__tabs');
        if (bar) bar.addEventListener('mouseleave', pillToActive);
        window.addEventListener('resize', pillToActive);
        requestAnimationFrame(pillToActive);
      }

      /* Fetched cards arrive after premium-motion has wrapped the page's CTAs
         for the hover roll, so their CTA gets the same wrap here. */
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function rollCta(card) {
        if (reduce) return;
        card.querySelectorAll('.product-card__cta').forEach(function (el) {
          if (el.dataset.clabRoll || el.children.length) return;
          var text = el.textContent.trim(); if (!text) return;
          var wrap = document.createElement('span'); wrap.className = 'clab-roll';
          ['clab-roll__line clab-roll__line--cur', 'clab-roll__line clab-roll__line--in'].forEach(function (cls, i) {
            var line = document.createElement('span'); line.className = cls; line.textContent = text;
            if (i) line.setAttribute('aria-hidden', 'true');
            wrap.appendChild(line);
          });
          el.textContent = ''; el.appendChild(wrap); el.dataset.clabRoll = '1';
        });
      }

      /* ---- recently viewed: handles from localStorage, cards fetched one by one ---- */
      var recentTrack = root.querySelector('[data-recent-track]');
      var recentEmpty = root.querySelector('[data-recent-empty]');
      var loading = null;
      function handles() {
        var list = [];
        try { list = JSON.parse(localStorage.getItem(STORE_KEY) || '[]'); } catch (e) {}
        var current = root.getAttribute('data-current-handle');
        var limit = parseInt(root.getAttribute('data-recent-limit'), 10) || 8;
        return list.filter(function (h) { return h && h !== current; }).slice(0, limit);
      }
      function loadRecent() {
        if (!recentTrack || loading) return loading;
        var list = handles();
        if (!list.length) {
          if (recentEmpty) recentEmpty.hidden = false;
          loading = Promise.resolve();
          return loading;
        }
        loading = Promise.all(list.map(function (h) {
          return fetch('/products/' + encodeURIComponent(h) + '?section_id=recently-viewed-card', { credentials: 'same-origin' })
            .then(function (r) { return r.ok ? r.text() : ''; })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              return doc.querySelector('.product-card');
            })
            .catch(function () { return null; });
        })).then(function (cards) {
          cards.forEach(function (c) { if (c) { rollCta(c); recentTrack.appendChild(c); } });
          var any = recentTrack.children.length > 0;
          if (recentEmpty) recentEmpty.hidden = any;
          if (updaters.recent) updaters.recent();
          document.dispatchEvent(new CustomEvent('clab:cards-added', { detail: { root: recentTrack } }));
        });
        return loading;
      }
      /* fetch in the background once the page has settled, so the tab opens instantly */
      if (recentTrack) {
        var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1500); };
        idle(function () { loadRecent(); });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // AReviews, the store's review app. Its widget reads the reviews through
    // the store's own app proxy and gets HTML back; we ask for the same HTML
    // and keep what we want: photo reviews first (its "Con imágenes" sort),
    // then text reviews at the minimum stars with enough to read.
    var AR_URL = '/apps/aliexpress_reviews';

    function arCountry() {
      try {
        if (window.Shopify && Shopify.routes && Shopify.routes.root && Shopify.routes.root !== '/') {
          return 'language=' + String(Shopify.locale || 'es').split('-')[0];
        }
        if (window.Shopify && Shopify.country) return 'country=' + String(Shopify.country).split('-')[0].toLowerCase();
      } catch (e) {}
      return '';
    }

    // AReviews answers with its whole widget (CSS and scripts included);
    // only the review list is parsed.
    function arSlim(html) {
      var i = html.indexOf('id="list"');
      var body = i > -1 ? html.slice(Math.max(0, html.lastIndexOf('<div', i))) : html;
      return body.replace(/<script[\s\S]*?<\/script>/gi, '').replace(/<style[\s\S]*?<\/style>/gi, '');
    }

    function parseAr(html) {
      if (!html) return [];
      var doc = new DOMParser().parseFromString(arSlim(html), 'text/html');
      return Array.prototype.map.call(doc.querySelectorAll('.item[data-id]'), function (it) {
        var txt = function (sel) {
          var el = it.querySelector(sel);
          return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
        };
        var pics = Array.prototype.map.call(it.querySelectorAll('.image_container img'), function (img) {
          var a = img.closest('a[href]');
          var full = a ? a.getAttribute('href') : '';
          return /^https:\/\//.test(full) ? full : (img.getAttribute('src') || img.getAttribute('data-src') || '');
        }).filter(function (u) { return /^https:\/\//.test(u); });
        return {
          name: txt('.areviews_user_name'),
          rating: it.querySelectorAll('.main_container_review_stars .fas.fa-star').length,
          text: txt('.comment'),
          reply: txt('.reply_container .reply_comment'),
          verified: !!it.querySelector('.arv-verified-badge'),
          pic: pics[0] || ''
        };
      });
    }

    function shortName(name) {
      var parts = String(name || '').trim().split(/\s+/).map(function (w) {
        return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
      });
      if (!parts[0]) return '';
      return parts.length > 1 ? parts[0] + ' ' + parts[1].charAt(0).toUpperCase() + '.' : parts[0];
    }

    // Page numbers AReviews offers for this query, read off its own pager.
    function arMaxPage(html) {
      var i = html.indexOf('pagination_container');
      if (i < 0) return 1;
      var max = 1;
      html.slice(i, i + 8000).replace(/>\s*(\d{1,4})\s*</g, function (m, n) {
        n = parseInt(n, 10);
        if (n > max) max = n;
        return m;
      });
      return max;
    }

    function arFetch(root, page, sort, rating) {
      var d = root.dataset;
      var mobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
      var body = new URLSearchParams({
        shop: d.arShop, page: String(page), product_id: d.arProduct,
        customer_reviews_status: '1', customer_id: '', sort_value: sort,
        customer_country: arCountry(), areviews_rating: rating || '',
        areviews_device: mobile ? 'mobile' : 'desktop'
      });
      return fetch(AR_URL, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: body
      }).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    }

    function arCard(root, rv) {
      var tpl = root.querySelector('[data-pcr-ar-tpl]');
      var full = root.querySelector('[data-pcr-ar-star-full]');
      var empty = root.querySelector('[data-pcr-ar-star-empty]');
      var card = tpl.content.firstElementChild.cloneNode(true);
      var q = function (sel) { return card.querySelector(sel); };
      var stars = q('[data-ar-stars]');
      for (var i = 1; i <= 5; i++) {
        var src = i <= rv.rating ? full : empty;
        if (src) stars.appendChild(src.content.firstElementChild.cloneNode(true));
      }
      // AReviews shows no dates, so neither do we.
      q('[data-ar-date]').remove();
      q('[data-ar-date-inline]').remove();
      var name = shortName(rv.name);
      if (name) q('[data-ar-name]').textContent = name;
      else q('.pdp-customer-reviews__card-meta').remove();
      q('[data-ar-title]').remove();
      if (rv.text) q('[data-ar-body]').textContent = rv.text;
      else q('[data-ar-body]').remove();
      if (rv.reply) { q('[data-ar-reply-body]').textContent = rv.reply; q('[data-ar-reply]').hidden = false; }
      else q('[data-ar-reply]').remove();
      if (rv.verified) q('[data-ar-verified]').hidden = false;
      else q('[data-ar-verified]').remove();
      if (rv.pic) {
        card.classList.add('has-media');
        var img = q('[data-ar-img]');
        img.src = rv.pic;
        img.alt = name || '';
        q('[data-ar-media]').hidden = false;
      } else {
        q('[data-ar-media]').remove();
      }
      return card;
    }

    var ARROW_PREV = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M10 4L6 8l4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var ARROW_NEXT = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M6 4l4 4-4 4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    // 1 … 4 5 6 … 12: first, last, and two either side of the current page.
    function pageList(cur, total) {
      var out = [];
      for (var p = 1; p <= total; p++) {
        if (p === 1 || p === total || Math.abs(p - cur) <= 1 || (cur <= 3 && p <= 4) || (cur >= total - 2 && p >= total - 3)) out.push(p);
        else if (out[out.length - 1] !== '…') out.push('…');
      }
      return out;
    }

    function arShowPage(root, page, fromClick) {
      var list = root.__arList || [];
      var per = Math.max(1, parseInt(root.dataset.arPerPage, 10) || 6);
      var total = Math.max(1, Math.ceil(list.length / per));
      page = Math.min(Math.max(1, page), total);
      root.__arPage = page;

      var grid = root.querySelector('.pdp-customer-reviews__grid');
      var frag = document.createDocumentFragment();
      list.slice((page - 1) * per, page * per).forEach(function (rv) { frag.appendChild(arCard(root, rv)); });
      grid.innerHTML = '';
      grid.appendChild(frag);

      arPager(root);

      if (typeof root.__pcrWire === 'function') root.__pcrWire();
      if (fromClick) {
        var head = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--site-header-offset'), 10) || 80;
        var top = grid.getBoundingClientRect().top + window.pageYOffset - head - 24;
        if (grid.getBoundingClientRect().top < head) window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    function arPager(root) {
      var list = root.__arList || [];
      var per = Math.max(1, parseInt(root.dataset.arPerPage, 10) || 6);
      var total = Math.max(1, Math.ceil(list.length / per));
      var page = root.__arPage || 1;
      var pager = root.querySelector('[data-pcr-pager]');
      if (pager) {
        pager.innerHTML = '';
        pager.hidden = total < 2;
        var btn = function (label, target, opts) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'pdp-customer-reviews__page' + (opts.arrow ? ' pdp-customer-reviews__page--arrow' : '');
          if (opts.html) b.innerHTML = label; else b.textContent = label;
          if (opts.aria) b.setAttribute('aria-label', opts.aria);
          if (opts.current) b.setAttribute('aria-current', 'page');
          if (opts.disabled) b.disabled = true;
          b.addEventListener('click', function () { if (!opts.current && !opts.disabled) arShowPage(root, target, true); });
          pager.appendChild(b);
        };
        btn(ARROW_PREV, page - 1, { html: true, arrow: true, aria: root.dataset.arPrev, disabled: page === 1 });
        pageList(page, total).forEach(function (p) {
          if (p === '…') {
            var gap = document.createElement('span');
            gap.className = 'pdp-customer-reviews__pager-gap';
            gap.textContent = '…';
            pager.appendChild(gap);
          } else {
            btn(String(p), p, { current: p === page });
          }
        });
        btn(ARROW_NEXT, page + 1, { html: true, arrow: true, aria: root.dataset.arNext, disabled: page === total });
      }
    }

    // AReviews' "Con imágenes" order puts the photo reviews first, so the
    // list can be shown from the first answer and grow as the other pages
    // arrive (three at a time), always in AReviews' page order.
    function loadAReviews(root) {
      var d = root.dataset;
      var minRating = parseInt(d.arMinRating, 10);
      if ([1, 4, 5].indexOf(minRating) === -1) minRating = 5;
      var minChars = parseInt(d.arMinChars, 10) || 0;
      var minShown = parseInt(d.arMinShown, 10) || 1;
      var per = Math.max(1, parseInt(d.arPerPage, 10) || 6);

      var pages = {};
      var last = 1;
      var shown = false;

      function rebuild() {
        var seen = {};
        var photos = [];
        var texts = [];
        for (var p = 1; p <= last && pages[p]; p++) {
          pages[p].forEach(function (rv) {
            if (rv.rating < minRating) return;
            if (!rv.pic && rv.text.length < minChars) return;
            if (!rv.pic && !rv.text) return;
            var key = (rv.name + '|' + rv.text).toLowerCase();
            if (seen[key]) return;
            seen[key] = true;
            (rv.pic ? photos : texts).push(rv);
          });
        }
        // AReviews' photo order slips a text review in here and there.
        return photos.concat(texts);
      }

      return new Promise(function (resolve) {
        var settled = false;
        var done = function (v) { if (!settled) { settled = true; resolve(v); } };

        function update(final) {
          var list = rebuild();
          if (!shown) {
            if (list.length >= minShown && (list.length >= per || final) && !root.__pcrReady && root.querySelector('[data-pcr-ar-tpl]')) {
              shown = true;
              root.__arList = list;
              root.setAttribute('data-pcr-paged', '');
              arShowPage(root, 1, false);
              var col = root.querySelector('.pdp-customer-reviews__col');
              if (col) col.classList.remove('is-ar-pending');
              done(true);
            } else if (final) {
              done(false);
            }
            return;
          }
          var cur = root.__arPage || 1;
          var before = (root.__arList || []).slice((cur - 1) * per, cur * per).length;
          root.__arList = list;
          if (before < per) arShowPage(root, cur, false);
          else arPager(root);
        }

        arFetch(root, 1, 'images', '').then(function (first) {
          pages[1] = parseAr(first);
          last = Math.min(arMaxPage(first), 60);
          var next = 2;
          var active = 0;
          update(last === 1);
          (function pump() {
            while (active < 3 && next <= last) {
              (function (p) {
                active++;
                arFetch(root, p, 'images', '').then(function (html) {
                  pages[p] = parseAr(html);
                }).then(function () {
                  active--;
                  update(next > last && active === 0);
                  pump();
                });
              })(next++);
            }
          })();
        }).catch(function () { done(false); });
      });
    }

    function boot(root) {
      if (!root.hasAttribute('data-pcr-ar')) { init(root); return; }
      var done = false;
      var go = function () { if (done) return; done = true; root.__pcrReady = true; init(root); };
      var start = function () {
        // If AReviews is slow the blocks stay and we stop waiting.
        var timer = setTimeout(go, 8000);
        loadAReviews(root).then(function () { clearTimeout(timer); go(); });
      };
      // Each AReviews answer is a full widget page, so nothing is asked for
      // until the shopper is getting close to the section.
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); start(); }
        }, { rootMargin: '900px 0px' });
        io.observe(root);
      } else {
        start();
      }
    }

    document.querySelectorAll('.pdp-customer-reviews').forEach(boot);

    function init(root) {
      root.style.setProperty('--pcr-clamp', parseInt(root.dataset.pcrClamp, 10) || 5);

      var released = false;
      function release() {
        if (released) return;
        released = true;
        var w = root.querySelector('[data-pcr-wrap]');
        var sm = root.querySelector('[data-pcr-showmore]');
        if (w) { w.style.maxHeight = ''; w.classList.remove('is-capped'); }
        if (sm) sm.hidden = true;
      }

      // Same as the home grid: the toggle is always wired, and whether it
      // shows is re-measured once the webfont lands and on resize. Paginated
      // grids swap their cards, so the wiring can be run again per page.
      var cards = [];
      function wire() {
      cards = [];
      root.querySelectorAll('.pdp-customer-reviews__card').forEach(function (card) {
        var bodies = card.querySelectorAll('[data-pcr-body]');
        var btn = card.querySelector('[data-pcr-more]');
        if (!bodies.length || !btn) return;
        var entry = {
          bodies: bodies,
          btn: btn,
          more: btn.textContent.trim(),
          less: root.dataset.pcrLess || (window.themeI18n || {}).read_less || 'Read less',
          open: false
        };
        cards.push(entry);
        btn.addEventListener('click', function () {
          entry.open = !entry.open;
          bodies.forEach(function (b) { b.classList.toggle('is-clamped', !entry.open); });
          btn.textContent = entry.open ? entry.less : entry.more;
          if (entry.open) release();
        });
      });
      measure();
      }

      function measure() {
        cards.forEach(function (c) {
          if (c.open) return;
          var overflows = false;
          c.bodies.forEach(function (b) {
            b.classList.add('is-clamped');
            if (b.scrollHeight - b.clientHeight > 2) overflows = true;
          });
          if (!overflows) c.bodies.forEach(function (b) { b.classList.remove('is-clamped'); });
          c.btn.hidden = !overflows;
        });
      }
      wire();
      root.__pcrWire = wire;
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
      window.addEventListener('resize', measure);

      // Paginated: every page is shown whole, the pager replaces the fade.
      if (root.hasAttribute('data-pcr-paged')) { release(); return; }

      var wrap = root.querySelector('[data-pcr-wrap]');
      var showmore = root.querySelector('[data-pcr-showmore]');
      var grid = root.querySelector('.pdp-customer-reviews__grid');
      if (!wrap || !showmore || !grid) return;
      var rows = parseInt(root.dataset.pcrRows, 10) || 2;

      function cap() {
        if (released) return;
        wrap.style.maxHeight = '';
        wrap.classList.remove('is-capped');
        var tops = [];
        Array.prototype.forEach.call(grid.children, function (c) {
          var t = Math.round(c.offsetTop);
          if (tops.indexOf(t) === -1) tops.push(t);
        });
        if (tops.length <= rows) { showmore.hidden = true; return; }
        wrap.style.maxHeight = (tops[rows] + 150) + 'px';
        wrap.classList.add('is-capped');
        showmore.hidden = false;
      }
      cap();
      window.addEventListener('resize', cap);

      showmore.querySelector('[data-pcr-expand]').addEventListener('click', function () {
        release();
        window.removeEventListener('resize', cap);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-fresh-heads"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Figures count up from 0 the first time the section comes into view.
       Same curve and timing as the home's clinical figures. A value that
       does not start with a number ("Daily") is left alone. */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('.fresh-heads').forEach(function (root) {
      var items = [];
      root.querySelectorAll('[data-countup]').forEach(function (el) {
        var m = (el.getAttribute('data-countup') || '').match(/^\s*([\d.,]+)(.*)$/);
        if (!m) return;
        var numStr = m[1].replace(',', '.');
        var decimals = (numStr.split('.')[1] || '').length;
        items.push({ el: el, target: parseFloat(numStr), suffix: m[2], decimals: decimals });
        if (!reduce) el.textContent = (0).toFixed(decimals) + m[2];
      });
      if (reduce || !items.length) return;
      var done = false;
      function run() {
        if (done) return; done = true;
        items.forEach(function (it) {
          var start = null, dur = 1300;
          function step(ts) {
            if (start === null) start = ts;
            var p = Math.min(1, (ts - start) / dur);
            var eased = 1 - Math.pow(1 - p, 3);
            it.el.textContent = (it.target * eased).toFixed(it.decimals) + it.suffix;
            if (p < 1) requestAnimationFrame(step);
            else it.el.textContent = it.target.toFixed(it.decimals) + it.suffix;
          }
          requestAnimationFrame(step);
        });
      }
      if (!('IntersectionObserver' in window)) { run(); return; }
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) { if (en.isIntersecting) { run(); io.disconnect(); } });
      }, { threshold: 0.3 });
      io.observe(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-real-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-pdp-real-results]').forEach((root) => {
      const track = root.querySelector('[data-track]');
      const dots = root.querySelectorAll('.pdp-real-results__dot');
      const tiles = root.querySelectorAll('.pdp-real-results__tile');
      if (!track) return;

      function step(dir) {
        const tile = track.querySelector('.pdp-real-results__tile');
        const w = tile ? tile.getBoundingClientRect().width + 8 : track.clientWidth * 0.8;
        track.scrollBy({ left: dir === 'prev' ? -w : w, behavior: 'smooth' });
      }
      root.querySelectorAll('[data-dir]').forEach((b) => b.addEventListener('click', () => step(b.dataset.dir)));

      // Update active dot on scroll
      track.addEventListener('scroll', () => {
        if (!tiles.length || !dots.length) return;
        const trackRect = track.getBoundingClientRect();
        let activeIdx = 0;
        let bestDist = Infinity;
        tiles.forEach((t, i) => {
          const r = t.getBoundingClientRect();
          const d = Math.abs(r.left - trackRect.left);
          if (d < bestDist) { bestDist = d; activeIdx = i; }
        });
        dots.forEach((d, i) => d.classList.toggle('is-active', i === activeIdx));
      }, { passive: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-tabs-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-pdp-tabs]').forEach((root) => {
      const tabs = [...root.querySelectorAll('[data-tab-target]')];
      if (!tabs.length) return;

      // Click → smooth-scroll to target
      tabs.forEach((t) => {
        t.addEventListener('click', (e) => {
          const sel = t.dataset.tabTarget;
          if (!sel || sel === '#') return;
          const target = document.querySelector(sel);
          if (!target) return;
          e.preventDefault();
          const headerOffset = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--site-header-offset'), 10) || 0;
          const tabsHeight = root.getBoundingClientRect().height;
          const top = target.getBoundingClientRect().top + window.scrollY - headerOffset - tabsHeight - 8;
          window.scrollTo({ top, behavior: 'smooth' });
        });
      });

      // Scroll-spy via IntersectionObserver — set the most visible target
      const targets = tabs
        .map((t) => ({ tab: t, target: document.querySelector(t.dataset.tabTarget) }))
        .filter((p) => p.target);
      if (!targets.length) return;

      function updateActive() {
        let best = targets[0];
        let bestScore = -Infinity;
        const tabsRect = root.getBoundingClientRect();
        const probeY = tabsRect.bottom + 4;
        targets.forEach((p) => {
          const r = p.target.getBoundingClientRect();
          // Score: how close the target's top is to the probe line, but penalise targets that are below it.
          const distance = probeY - r.top;
          if (distance >= 0 && distance < r.height + tabsRect.height) {
            // overlap with probe area
            if (distance > bestScore) { bestScore = distance; best = p; }
          }
        });
        tabs.forEach((t) => t.classList.toggle('is-active', t === best.tab));
        // ensure active tab visible in scrolled tabs row
        if (best.tab) {
          const tab = best.tab;
          const innerRect = root.querySelector('.pdp-tabs__inner').getBoundingClientRect();
          const tr = tab.getBoundingClientRect();
          if (tr.left < innerRect.left || tr.right > innerRect.right) {
            tab.scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
          }
        }
      }
      let raf;
      window.addEventListener('scroll', () => {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(updateActive);
      }, { passive: true });
      updateActive();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["real-people"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const desktopMQ = window.matchMedia('(min-width: 1024px)');
    const DRAG_THRESHOLD = 5;

    /* Desktop drag-to-scroll for horizontal tracks.
       Per drag_scroll_click_swallow memory: defer setPointerCapture
       until movement passes threshold + skip clicks on interactive targets. */
    function enableDragScroll(track) {
      let startX = 0, startY = 0, startScrollLeft = 0;
      let pointerId = null, dragging = false, captured = false;

      const isInteractive = (el) =>
        !!(el && el.closest && el.closest('a, button, input, textarea, select, [role="button"], [contenteditable]'));

      track.addEventListener('pointerdown', (e) => {
        if (!desktopMQ.matches) return;
        if (e.pointerType !== 'mouse') return;
        if (e.button !== 0) return;
        pointerId = e.pointerId;
        startX = e.clientX;
        startY = e.clientY;
        startScrollLeft = track.scrollLeft;
        dragging = true;
        captured = false;
      });

      track.addEventListener('pointermove', (e) => {
        if (!dragging || e.pointerId !== pointerId) return;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        if (!captured) {
          if (Math.abs(dx) < DRAG_THRESHOLD && Math.abs(dy) < DRAG_THRESHOLD) return;
          if (Math.abs(dy) > Math.abs(dx)) { dragging = false; return; }
          if (isInteractive(e.target)) { dragging = false; return; }
          try { track.setPointerCapture(pointerId); } catch (_) {}
          captured = true;
          track.classList.add('is-dragging');
          track.style.scrollSnapType = 'none';
        }
        track.scrollLeft = startScrollLeft - dx;
        e.preventDefault();
      });

      const endDrag = (e) => {
        if (!dragging) return;
        if (e && e.pointerId !== pointerId) return;
        dragging = false;
        if (captured) {
          try { track.releasePointerCapture(pointerId); } catch (_) {}
          track.classList.remove('is-dragging');
          track.style.scrollSnapType = '';
        }
        pointerId = null;
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);

      /* Swallow the trailing click after a real drag so cards inside the
         track don't navigate on drop. */
      track.addEventListener('click', (e) => {
        if (track.classList.contains('is-dragging-just-ended')) {
          e.preventDefault();
          e.stopPropagation();
          track.classList.remove('is-dragging-just-ended');
        }
      }, true);
      track.addEventListener('pointerup', () => {
        if (captured) {
          track.classList.add('is-dragging-just-ended');
          setTimeout(() => track.classList.remove('is-dragging-just-ended'), 50);
        }
      });
    }

    document.querySelectorAll('[data-real-people]').forEach((root) => {
      const track = root.querySelector('[data-track]');
      if (!track) return;
      root.querySelectorAll('[data-dir]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const card = track.querySelector('.real-people__card');
          const step = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
          track.scrollBy({ left: btn.dataset.dir === 'prev' ? -step : step, behavior: 'smooth' });
        });
      });
      enableDragScroll(track);

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let auto = null;
        let stopped = false;
        const step = () => {
          const card = track.querySelector('.real-people__card');
          const w = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
          const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
          track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + w, behavior: 'smooth' });
        };
        const play = () => { if (!stopped && !auto) auto = setInterval(step, 4500); };
        const pause = () => { clearInterval(auto); auto = null; };
        /* A click on the arrows or a drag means the visitor is steering; the
           carousel should not fight them for the rest of the visit. */
        const surrender = () => { stopped = true; pause(); };
        root.addEventListener('mouseenter', pause);
        root.addEventListener('mouseleave', play);
        root.querySelectorAll('[data-dir]').forEach((b) => b.addEventListener('click', surrender));
        track.addEventListener('pointerdown', surrender);
        document.addEventListener('visibilitychange', () => document.hidden ? pause() : play());
        play();
      }

      /* Progress bar: the thumb is the viewport's share of the track and
         slides with scrollLeft. */
      const bar = root.querySelector('[data-scrollbar]');
      const thumb = bar && bar.querySelector('[data-thumb]');
      if (bar && thumb) {
        let ticking = false;
        const update = () => {
          const barW = bar.clientWidth;
          const ratio = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
          const thumbW = Math.max(20, Math.round(barW * ratio));
          thumb.style.width = thumbW + 'px';
          const maxScroll = Math.max(1, track.scrollWidth - track.clientWidth);
          const x = Math.round((track.scrollLeft / maxScroll) * Math.max(0, barW - thumbW));
          thumb.style.transform = 'translateX(' + x + 'px)';
        };
        track.addEventListener('scroll', () => {
          if (!ticking) {
            requestAnimationFrame(() => { update(); ticking = false; });
            ticking = true;
          }
        }, { passive: true });
        window.addEventListener('resize', update);
        window.addEventListener('load', update);
        update();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.reviews-grid').forEach(function (root) {
      root.style.setProperty('--rv-clamp', parseInt(root.dataset.rvClamp, 10) || 4);

      var released = false;
      function release() {
        if (released) return;
        released = true;
        var w = root.querySelector('[data-rv-wrap]');
        var sm = root.querySelector('[data-rv-showmore]');
        if (w) { w.style.maxHeight = ''; w.classList.remove('is-capped'); }
        if (sm) sm.hidden = true;
      }

      // The toggle is wired once and always works; only whether it SHOWS
      // depends on measurement, which is re-run after the webfont lands and
      // on resize — a first pass in the fallback face under-measures the
      // text and would otherwise hide the control for good.
      var cards = [];
      root.querySelectorAll('.reviews-grid__card').forEach(function (card) {
        var bodies = card.querySelectorAll('[data-rv-body]');
        var btn = card.querySelector('[data-rv-more]');
        if (!bodies.length || !btn) return;
        var entry = {
          bodies: bodies,
          btn: btn,
          more: btn.textContent.trim(),
          less: root.dataset.rvLess || (window.themeI18n || {}).read_less || 'Read less',
          open: false
        };
        cards.push(entry);
        btn.addEventListener('click', function () {
          entry.open = !entry.open;
          bodies.forEach(function (b) { b.classList.toggle('is-clamped', !entry.open); });
          btn.textContent = entry.open ? entry.less : entry.more;
          if (entry.open) release();
        });
      });

      function measure() {
        cards.forEach(function (c) {
          if (c.open) return;
          var overflows = false;
          c.bodies.forEach(function (b) {
            b.classList.add('is-clamped');
            if (b.scrollHeight - b.clientHeight > 2) overflows = true;
          });
          if (!overflows) c.bodies.forEach(function (b) { b.classList.remove('is-clamped'); });
          c.btn.hidden = !overflows;
        });
      }
      measure();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
      window.addEventListener('resize', measure);

      // Cap the grid just past the chosen row, then fade what is left.
      var wrap = root.querySelector('[data-rv-wrap]');
      var showmore = root.querySelector('[data-rv-showmore]');
      var list = root.querySelector('.reviews-grid__list');
      if (!wrap || !showmore || !list) return;
      var rows = parseInt(root.dataset.rvRows, 10) || 2;

      function cap() {
        if (released) return;
        wrap.style.maxHeight = '';
        wrap.classList.remove('is-capped');
        var tops = [];
        Array.prototype.forEach.call(list.children, function (c) {
          var t = Math.round(c.offsetTop);
          if (tops.indexOf(t) === -1) tops.push(t);
        });
        if (tops.length <= rows) { showmore.hidden = true; return; }
        // A slice of the next row stays visible under the gradient.
        wrap.style.maxHeight = (tops[rows] + 150) + 'px';
        wrap.classList.add('is-capped');
        showmore.hidden = false;
      }
      cap();
      window.addEventListener('resize', cap);

      showmore.querySelector('[data-rv-expand]').addEventListener('click', function () {
        release();
        window.removeEventListener('resize', cap);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scratch-popup"]) return;
  try {
    
  (function () {
    'use strict';
    var REVISION = '2025-07-15';
    function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
    function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

    function init() {
      document.querySelectorAll('[data-scratch-popup]').forEach(setup);
    }
    function setup(root) {
      if (!root || root.dataset.scratchReady) return;
      root.dataset.scratchReady = '1';

      var vip = root.getAttribute('data-mode') === 'vip';
      // VIP signups keep their own state, so a past classic win does not hide it.
      var DONE_KEY = vip ? 'obs:vip-done' : 'obs:scratch-done';
      var SNOOZE_KEY = vip ? 'obs:vip-snooze' : 'obs:scratch-snooze';
      var alwaysOpen = root.getAttribute('data-always-open') === 'true';
      var eventName = root.getAttribute('data-event') || 'Scratch Win';
      var profileProp = (root.getAttribute('data-profile-prop') || '').trim();
      var design = root.getAttribute('data-design-mode') === 'true';
      var enabled = root.getAttribute('data-enabled') === 'true';
      var delayMs = (parseFloat(root.getAttribute('data-delay')) || 0) * 1000;
      var snoozeDays = parseFloat(root.getAttribute('data-snooze-days')) || 7;
      var threshold = (parseFloat(root.getAttribute('data-threshold')) || 45) / 100;
      var companyId = (root.getAttribute('data-klaviyo-key') || '').trim();
      var listId = (root.getAttribute('data-klaviyo-list') || '').trim();
      var source = root.getAttribute('data-source') || 'Scratch popup';
      var foilText = root.getAttribute('data-foil-text') || 'RASCA AQUÍ';

      var canvas = root.querySelector('[data-scratch-canvas]');
      var card = root.querySelector('[data-scratch-card]');
      var form = root.querySelector('[data-scratch-form]');
      var success = root.querySelector('[data-scratch-success]');
      var errorEl = root.querySelector('[data-scratch-error]');
      var pctEl = root.querySelector('[data-scratch-pct]');
      var codeEl = root.querySelector('[data-scratch-code]');
      var copyBtn = root.querySelector('[data-scratch-copy]');
      var sideVideo = root.querySelector('.scratch-popup__side video');
      var emailEl = root.querySelector('[data-scratch-email]');
      var consentEl = root.querySelector('[data-scratch-consent]');
      var submitBtn = root.querySelector('[data-scratch-submit]');

      var prizes = [];
      try { prizes = JSON.parse(root.querySelector('[data-scratch-prizes]').textContent) || []; } catch (e) {}
      // A prize can be limited to mobile or desktop (750 px, the theme's breakpoint).
      var isDesktop = window.matchMedia('(min-width: 750px)').matches;
      // VIP has no prize to draw: the card shows the fixed text from the markup.
      if (vip) prizes = [{ code: '', pct: null, weight: 1 }];
      else prizes = prizes.filter(function (p) {
        if (!p || !p.code || !(p.weight > 0)) return false;
        return !p.device || p.device === 'all' || p.device === (isDesktop ? 'desktop' : 'mobile');
      });
      if (!prizes.length) return;

      function pickPrize() {
        var total = prizes.reduce(function (s, p) { return s + p.weight; }, 0);
        var r = Math.random() * total;
        for (var i = 0; i < prizes.length; i++) { r -= prizes[i].weight; if (r <= 0) return prizes[i]; }
        return prizes[prizes.length - 1];
      }

      var prize = null, opened = false, revealed = false, strokes = 0, ctx = null, last = null, drawing = false;

      // Gold foil painted on the canvas: gradient, a little grain, the label.
      function paintFoil() {
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var w = card.clientWidth, h = card.clientHeight;
        canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
        ctx = canvas.getContext('2d');
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        // VIP gets a deeper, more saturated gold than the classic champagne foil.
        var f = vip
          ? { stops: [[0, '#8C6A1F'], [0.28, '#F3D27A'], [0.52, '#B8892E'], [0.76, '#FFE9A8'], [1, '#9C7424']], grain: '#5E4512' }
          : { stops: [[0, '#D9C6A5'], [0.35, '#F1E6CF'], [0.6, '#CDB68C'], [1, '#E9DCC2']], grain: '#8A7449', stripe: '#B9A47B', text: 'rgba(255,255,255,0.92)' };
        var g = ctx.createLinearGradient(0, 0, w, h);
        f.stops.forEach(function (st) { g.addColorStop(st[0], st[1]); });
        ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
        ctx.globalAlpha = 0.08;
        for (var i = 0; i < 900; i++) {
          ctx.fillStyle = i % 2 ? '#FFFFFF' : f.grain;
          ctx.fillRect(Math.random() * w, Math.random() * h, 1.5, 1.5);
        }
        var font = getComputedStyle(root).fontFamily || 'sans-serif';
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        if (vip) {
          // A soft sheen instead of the scratch stripes, and the text pressed
          // into the foil: light edge below, dark edge above, letters a shade
          // deeper than the gold.
          ctx.globalAlpha = 1;
          var sheen = ctx.createLinearGradient(0, 0, w, h);
          sheen.addColorStop(0.3, 'rgba(255,248,220,0)');
          sheen.addColorStop(0.47, 'rgba(255,248,220,0.28)');
          sheen.addColorStop(0.62, 'rgba(255,248,220,0)');
          ctx.fillStyle = sheen; ctx.fillRect(0, 0, w, h);
          var fs = Math.round(w * 0.1), cx = w / 2, cy = h / 2;
          ctx.font = '500 ' + fs + 'px ' + font;
          ctx.letterSpacing = '-0.5px';
          ctx.fillStyle = 'rgba(255,244,210,0.7)'; ctx.fillText(foilText, cx, cy + 1.2);
          ctx.fillStyle = 'rgba(70,46,6,0.55)'; ctx.fillText(foilText, cx, cy - 1);
          var ink = ctx.createLinearGradient(0, cy - fs / 2, 0, cy + fs / 2);
          ink.addColorStop(0, '#A07524'); ink.addColorStop(1, '#C39436');
          ctx.fillStyle = ink; ctx.fillText(foilText, cx, cy);
          ctx.letterSpacing = '0px';
        } else {
          ctx.globalAlpha = 0.25; ctx.strokeStyle = f.stripe; ctx.lineWidth = Math.max(10, w * 0.06); ctx.lineCap = 'round';
          for (var s = 0; s < 4; s++) { ctx.beginPath(); ctx.moveTo(w * (0.28 + s * 0.09), h * 0.72); ctx.lineTo(w * (0.4 + s * 0.09), h * 0.26); ctx.stroke(); }
          ctx.globalAlpha = 1;
          ctx.fillStyle = f.text;
          ctx.font = '500 ' + Math.round(w * 0.11) + 'px ' + font;
          ctx.fillText(foilText, w / 2, h / 2);
        }
        ctx.globalCompositeOperation = 'destination-out';
        ctx.lineWidth = w * 0.14; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
      }
      function pos(e) {
        var r = canvas.getBoundingClientRect();
        return { x: e.clientX - r.left, y: e.clientY - r.top };
      }
      function scratch(p) {
        if (!ctx) return;
        ctx.beginPath();
        ctx.moveTo((last || p).x, (last || p).y);
        ctx.lineTo(p.x, p.y);
        ctx.stroke();
        last = p;
      }
      function clearedRatio() {
        var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
        var clear = 0, sampled = 0;
        for (var i = 3; i < data.length; i += 32) { sampled++; if (data[i] === 0) clear++; }
        return sampled ? clear / sampled : 0;
      }
      function reveal() {
        if (revealed) return;
        revealed = true;
        card.classList.add('is-revealed');
        root.classList.add('is-scratched');
        var sub = root.querySelector('[data-scratch-subtitle]');
        if (sub) sub.hidden = true;
        if (form) { form.hidden = false; if (emailEl) setTimeout(function () { emailEl.focus({ preventScroll: true }); }, 350); }
      }
      function maybeReveal(force) {
        if (revealed) return;
        if (!force && (++strokes % 6) !== 0) return;
        if (clearedRatio() > threshold) reveal();
      }
      canvas.addEventListener('pointerdown', function (e) { drawing = true; last = null; canvas.setPointerCapture && canvas.setPointerCapture(e.pointerId); scratch(pos(e)); e.preventDefault(); });
      canvas.addEventListener('pointermove', function (e) { if (!drawing) return; scratch(pos(e)); maybeReveal(false); e.preventDefault(); });
      function stop() { if (!drawing) return; drawing = false; last = null; maybeReveal(true); }
      canvas.addEventListener('pointerup', stop);
      canvas.addEventListener('pointercancel', stop);
      canvas.addEventListener('pointerleave', stop);

      function openPopup() {
        if (opened) return;
        opened = true;
        prize = pickPrize();
        if (pctEl && !vip) pctEl.textContent = prize.pct + '%';
        if (codeEl && !vip) codeEl.textContent = prize.code;
        root.classList.add('is-mounted');
        root.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('scratch-popup-open');
        paintFoil();
        setTimeout(function () { root.classList.add('is-open'); }, 20);
        if (sideVideo) {
          sideVideo.muted = true;
          sideVideo.playsInline = true;
          sideVideo.setAttribute('playsinline', '');
          var go = sideVideo.play();
          if (go && go.catch) go.catch(function () {});
        }
      }
      function closePopup(done) {
        if (sideVideo) sideVideo.pause();
        root.classList.remove('is-open');
        document.documentElement.classList.remove('scratch-popup-open');
        root.setAttribute('aria-hidden', 'true');
        setTimeout(function () { root.classList.remove('is-mounted'); }, 360);
        if (done) lsSet(DONE_KEY, '1');
        else lsSet(SNOOZE_KEY, String(Date.now() + snoozeDays * 864e5));
      }
      root.querySelectorAll('[data-scratch-close]').forEach(function (b) { b.addEventListener('click', function () { closePopup(!!lsGet(DONE_KEY)); }); });
      // No close on a click outside the panel: aiming at the small consent
      // box and missing it used to close the popup and lose the discount.
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('is-open')) closePopup(!!lsGet(DONE_KEY)); });

      // Klaviyo client API: subscribe to the list (double opt-in follows the list's setting).
      function klaviyoPost(path, payload) {
        return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', 'revision': REVISION },
          body: JSON.stringify(payload)
        });
      }
      function subscribe(email) {
        var props = {};
        if (vip) { if (profileProp) props[profileProp] = true; }
        else props['Scratch prize'] = prize.code;
        var profile = { data: { type: 'profile', attributes: { email: email, properties: props } } };
        if (listId) {
          profile.data.attributes.subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };
          return klaviyoPost('subscriptions', { data: { type: 'subscription', attributes: { custom_source: source, profile: profile }, relationships: { list: { data: { type: 'list', id: listId } } } } });
        }
        return klaviyoPost('profiles', profile);
      }
      function trackWin(email) {
        return klaviyoPost('events', { data: { type: 'event', attributes: {
          properties: vip ? { source: source } : { discount_code: prize.code, discount_pct: prize.pct },
          metric: { data: { type: 'metric', attributes: { name: eventName } } },
          profile: { data: { type: 'profile', attributes: { email: email } } }
        } } }).catch(function () {});
      }
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (emailEl.value || '').trim();
        if (errorEl) errorEl.hidden = true;
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { emailEl.focus(); if (errorEl) { errorEl.textContent = emailEl.getAttribute('data-invalid') || 'Revisa el email.'; errorEl.hidden = false; } return; }
        if (consentEl && !consentEl.checked) { consentEl.focus(); if (errorEl) { errorEl.textContent = consentEl.getAttribute('data-invalid') || 'Marca la casilla para recibir el código.'; errorEl.hidden = false; } return; }
        if (!companyId) { if (errorEl) errorEl.hidden = false; return; }
        submitBtn.disabled = true;
        subscribe(email).then(function (r) {
          if (!r.ok && r.status !== 202) throw new Error('subscribe ' + r.status);
          return trackWin(email);
        }).then(function () {
          try { window.klaviyo && window.klaviyo.push && window.klaviyo.push(['identify', { '$email': email }]); } catch (err) {}
          lsSet(DONE_KEY, '1');
          form.hidden = true;
          if (success) success.hidden = false;
        }).catch(function () {
          submitBtn.disabled = false;
          if (errorEl) { errorEl.textContent = errorEl.getAttribute('data-generic') || errorEl.textContent; errorEl.hidden = false; }
        });
      });
      // "Seguir comprando" closes the popup where the visitor already is; on
      // the preview page there is nothing behind it, so the link goes to the shop.
      var continueBtn = root.querySelector('[data-scratch-continue]');
      if (continueBtn) continueBtn.addEventListener('click', function (e) {
        if (alwaysOpen) return;
        e.preventDefault();
        closePopup(true);
      });
      if (copyBtn) copyBtn.addEventListener('click', function () {
        var lab = copyBtn.querySelector('[data-scratch-copy-label]');
        try { navigator.clipboard.writeText(codeEl.textContent.trim()).then(function () { if (lab) lab.textContent = copyBtn.getAttribute('data-copied') || 'Copiado'; }); } catch (e) {}
      });

      if (design) { if (enabled) openPopup(); return; }
      if (!enabled) return;
      // Preview instances (the hidden VIP page) open on every visit.
      if (!alwaysOpen) {
        if (lsGet(DONE_KEY)) return;
        var snooze = parseInt(lsGet(SNOOZE_KEY) || '0', 10);
        if (snooze && snooze > Date.now()) return;
      }
      setTimeout(openPopup, delayMs);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', function (e) { if (e.target && e.target.querySelector && e.target.querySelector('[data-scratch-popup]')) init(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["see-how-it-works"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function arm(video) {
      if (video.dataset.shArmed === '1') return;
      video.dataset.shArmed = '1';
      var play = function () {
        video.muted = true; video.defaultMuted = true; video.playsInline = true; video.loop = true;
        if (video.preload !== 'auto') video.preload = 'auto';
        var p = video.play(); if (p && p.catch) p.catch(function () {});
      };
      if (!('IntersectionObserver' in window)) { play(); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) play(); else if (!video.paused) video.pause(); });
      }, { rootMargin: '300px 0px' }).observe(video);
    }
    function armAll() { document.querySelectorAll('[data-sh-video]').forEach(arm); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', armAll); else armAll();
    document.addEventListener('shopify:section:load', armAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-now-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const bar = document.querySelector('[data-shop-now-bar]');
    if (!bar) return;

    const offerEl = bar.querySelector('[data-snb-offer]');
    if (offerEl) {
      const map = {};
      (offerEl.dataset.map || '').split('~~').forEach((line) => {
        const i = line.indexOf('|');
        if (i === 2) map[line.slice(0, 2)] = line.slice(3);
      });
      const countryName = (cc) => {
        try { return new Intl.DisplayNames([document.documentElement.lang || 'es'], { type: 'region' }).of(cc); } catch (e) { return cc; }
      };
      const show = (cc) => {
        if (!cc) return;
        const tpl = map[cc] || offerEl.dataset.default || '';
        const text = tpl.replace('[COUNTRY]', countryName(cc));
        if (text && offerEl.textContent !== text) offerEl.textContent = text;
      };
      fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => {
          const cc = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
          if (cc && cc !== offerEl.dataset.cc) show(String(cc).toUpperCase());
        })
        .catch(() => {});
    }

    const threshold = parseInt(bar.dataset.threshold, 10) || 400;
    let visible = null;

    function apply() {
      const shouldShow = window.scrollY > threshold;
      if (shouldShow === visible) return;
      visible = shouldShow;
      bar.classList.toggle('is-visible', shouldShow);
      // The header docks under the bar rather than behind it.
      document.documentElement.style.setProperty(
        '--shopbar-h', shouldShow ? bar.offsetHeight + 'px' : '0px'
      );
      window.dispatchEvent(new CustomEvent('shopbar:toggle'));
    }

    apply();
    window.addEventListener('scroll', apply, { passive: true });
    window.addEventListener('resize', apply);

    // Countdown: to the shipping cut-off, to a date, or (daily) to midnight in
    // the visitor's own time zone (the device clock), so it hits 00:00 in
    // Mexico, Chile or the US at their midnight, not Madrid's.
    const timer = bar.querySelector('[data-snb-timer]');
    if (!timer) return;
    const daily = timer.dataset.daily === 'true';
    if (timer.dataset.mode === 'cutoff') { cutoff(); return; }
    const fixed = timer.dataset.end ? new Date(timer.dataset.end) : null;
    const fixedOk = fixed && !isNaN(fixed.getTime());
    const hEl = timer.querySelector('[data-hours]');
    const mEl = timer.querySelector('[data-mins]');
    const sEl = timer.querySelector('[data-secs]');
    const pad = (n) => (n < 10 ? '0' : '') + n;
    function endTime() {
      if (fixedOk && !daily) return fixed.getTime();
      const d = new Date();
      d.setHours(23, 59, 59, 999);
      let t = d.getTime();
      if (fixedOk && fixed.getTime() < t) t = fixed.getTime();
      return t;
    }
    function tick() {
      let diff = endTime() - Date.now();
      if (diff <= 0) {
        if (!daily && fixedOk) { bar.style.display = 'none'; return; }
        diff = 0;
      }
      const secs = Math.floor((diff % 60000) / 1000);
      const mins = Math.floor((diff % 3600000) / 60000);
      const hours = Math.floor(diff / 3600000);
      hEl.textContent = pad(hours); mEl.textContent = pad(mins); sEl.textContent = pad(secs);
      setTimeout(tick, 1000 - (Date.now() % 1000));
    }
    tick();

    // Shipping cut-off, Madrid time: on a working day before the cut-off the
    // bar counts down to it ("lo tramitamos hoy"); otherwise it names the next working
    // day and hides the clock, so it never promises what the warehouse won't do.
    function cutoff() {
      const hEl = timer.querySelector('[data-hours]');
      const mEl = timer.querySelector('[data-mins]');
      const sEl = timer.querySelector('[data-secs]');
      const pad = (n) => (n < 10 ? '0' : '') + n;
      const cutH = parseInt(timer.dataset.cutoff, 10) || 18;
      const holidays = (timer.dataset.holidays || '').split(',').map((x) => x.trim()).filter(Boolean);
      const textEl = bar.querySelector('[data-snb-text]');
      const before = textEl ? textEl.textContent : '';
      const afterTpl = textEl ? (textEl.dataset.after || '') : '';
      const dayNames = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
      let fmt;
      try {
        fmt = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
      } catch (e) { fmt = null; }
      function now() {
        if (!fmt) { const d = new Date(); return { y: d.getFullYear(), mo: d.getMonth() + 1, d: d.getDate(), h: d.getHours(), mi: d.getMinutes(), s: d.getSeconds() }; }
        const p = {};
        fmt.formatToParts(new Date()).forEach((x) => { p[x.type] = x.value; });
        return { y: +p.year, mo: +p.month, d: +p.day, h: (+p.hour) % 24, mi: +p.minute, s: +p.second };
      }
      function working(y, mo, d) {
        const dt = new Date(Date.UTC(y, mo - 1, d));
        const wd = dt.getUTCDay();
        return wd !== 0 && wd !== 6 && holidays.indexOf(dt.toISOString().slice(0, 10)) === -1;
      }
      function nextWorking(y, mo, d) {
        for (let k = 1; k < 15; k++) {
          const dt = new Date(Date.UTC(y, mo - 1, d + k));
          if (working(dt.getUTCFullYear(), dt.getUTCMonth() + 1, dt.getUTCDate())) return { k: k, wd: dt.getUTCDay() };
        }
        return { k: 1, wd: 1 };
      }
      function run() {
        const n = now();
        const left = cutH * 3600 - (n.h * 3600 + n.mi * 60 + n.s);
        if (working(n.y, n.mo, n.d) && left > 0) {
          timer.classList.remove('is-off');
          if (textEl && textEl.textContent !== before) textEl.textContent = before;
          hEl.textContent = pad(Math.floor(left / 3600));
          mEl.textContent = pad(Math.floor((left % 3600) / 60));
          sEl.textContent = pad(left % 60);
        } else {
          const nx = nextWorking(n.y, n.mo, n.d);
          const day = nx.k === 1 ? 'mañana' : 'el ' + dayNames[nx.wd];
          const t = afterTpl.replace('[DAY]', day);
          if (textEl && t && textEl.textContent !== t) textEl.textContent = t;
          timer.classList.add('is-off');
        }
        setTimeout(run, 1000 - (Date.now() % 1000));
      }
      run();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-proof"] && !Shopify.designMode) return;
  try {
    

  (function () {
    /* Liquid satin (after the Represent Prestige background). A height
       field of broad folds is lit like fabric: a key light from the top
       left, a softer fill from the right (so no fold ever goes flat), a
       little shade in the creases, then mapped onto a lilac ramp sampled
       from the glossy-lavender reference shots, with a white gloss on top.
       The fold phase is a slope bent by three long sine waves: smooth at any
       size, no grid, exact gradient. It renders at screen resolution with
       a dither, so there is nothing to pixelate and no banding. */
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var VERT = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}';
    var FRAG = [
      '#ifdef GL_FRAGMENT_PRECISION_HIGH', 'precision highp float;', '#else', 'precision mediump float;', '#endif',
      'uniform vec2 u_res;uniform float u_t;uniform float u_unit;',
      'vec3 ramp(float x){',
      /* #7B6CB2 > #8E80C4 > #A898DA > #C5B4F4 > #E2D9F6 > #F6F2FC */
      ' vec3 c0=vec3(.482,.424,.698),c1=vec3(.557,.502,.769),c2=vec3(.659,.596,.855),c3=vec3(.773,.706,.957),c4=vec3(.886,.851,.965),c5=vec3(.965,.949,.988);',
      ' x=clamp(x,0.,1.);',
      ' if(x<.2)return mix(c0,c1,x/.2);',
      ' if(x<.4)return mix(c1,c2,(x-.2)/.2);',
      ' if(x<.6)return mix(c2,c3,(x-.4)/.2);',
      ' if(x<.8)return mix(c3,c4,(x-.6)/.2);',
      ' return mix(c4,c5,(x-.8)/.2);}',
      'void main(){',
      ' vec2 uv=gl_FragCoord.xy/u_res;',
      ' vec2 p=(gl_FragCoord.xy-.5*u_res)/u_unit;',
      ' float t=u_t;',
      ' vec2 dr=vec2(.912,-.410),d1=vec2(0.,1.),d2=vec2(.781,.625),d3=vec2(-.874,.486);',
      ' float a1=dot(p,d1)*1.47+t*.35+.7,a2=dot(p,d2)*1.19-t*.26+2.1,a3=dot(p,d3)*2.03+t*.44+4.2;',
      ' vec2 g=4.8*dr+3.528*cos(a1)*d1+1.856*cos(a2)*d2+1.949*cos(a3)*d3;',
      ' float ph=4.8*dot(p,dr)+2.4*sin(a1)+1.56*sin(a2)+.96*sin(a3)-t*1.1;',
      ' float s=.5+.5*sin(ph);',
      ' vec3 n=normalize(vec3(-.07*cos(ph)*g,1.));',
      ' vec3 L1=vec3(-.451,.551,.702),L2=vec3(.619,.2,.759);',
      ' float dif=clamp(dot(n,L1),0.,1.)*.72+clamp(dot(n,L2),0.,1.)*.45;',
      ' float sp=pow(clamp(dot(n,normalize(L1+vec3(0.,0.,1.))),0.,1.),34.)+.5*pow(clamp(dot(n,normalize(L2+vec3(0.,0.,1.))),0.,1.),34.);',
      ' float x=(.6+(dif-.846)*1.5)*mix(.62,1.,s);',
      /* a touch deeper lilac at the top, lighter towards the stats */
      ' x-=.12*(uv.y-.5);',
      /* white gloss on the ridges, like the lavender cream shots */
      ' vec3 col=mix(ramp(x),vec3(1.),clamp(sp*1.1,0.,1.)*.9);',
      /* interleaved-gradient dither: dark purple gradients band in 8 bits */
      ' float dn=fract(52.9829189*fract(dot(gl_FragCoord.xy,vec2(.06711056,.00583715))));',
      ' gl_FragColor=vec4(col+(dn-.5)*(2./255.),1.);',
      '}'
    ].join('\n');

    function glRenderer(canvas) {
      var gl = canvas.getContext('webgl', { alpha: false, antialias: false, depth: false, stencil: false, powerPreference: 'low-power' });
      if (!gl) return null;
      function sh(type, src) {
        var o = gl.createShader(type); gl.shaderSource(o, src); gl.compileShader(o);
        return gl.getShaderParameter(o, gl.COMPILE_STATUS) ? o : null;
      }
      var vs = sh(gl.VERTEX_SHADER, VERT), fs = sh(gl.FRAGMENT_SHADER, FRAG);
      if (!vs || !fs) return null;
      var prog = gl.createProgram(); gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
      if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return null;
      gl.useProgram(prog);
      var buf = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, buf);
      gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
      var loc = gl.getAttribLocation(prog, 'a'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      var uRes = gl.getUniformLocation(prog, 'u_res'), uT = gl.getUniformLocation(prog, 'u_t'), uUnit = gl.getUniformLocation(prog, 'u_unit');
      return {
        kind: 'webgl',
        draw: function (t, W, H) {
          gl.viewport(0, 0, W, H); gl.uniform2f(uRes, W, H); gl.uniform1f(uT, t);
          /* fold size follows the long side; portrait gets a tighter scale */
          gl.uniform1f(uUnit, Math.max(W, H) * (W >= H ? .5 : .36));
          gl.drawArrays(gl.TRIANGLES, 0, 3);
        }
      };
    }

    function start(sec) {
      if (sec.__spAurora) return;
      var wrap = sec.querySelector('[data-sp-aurora]');
      var canvas = wrap && wrap.querySelector('[data-sp-canvas]');
      if (!canvas) return;
      var r = glRenderer(canvas);
      if (!r) return;
      var speed = (parseFloat(wrap.dataset.spSpeed) || 100) / 100;
      var state = sec.__spAurora = { renderer: r.kind, frames: 0 };
      var W = 0, H = 0, visible = true, raf = null, lost = false, t0 = performance.now();

      function size() {
        var b = wrap.getBoundingClientRect();
        var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
        var w = Math.max(1, b.width * dpr), h = Math.max(1, b.height * dpr);
        /* screen resolution, capped at ~2.2M px for very large screens */
        var k = Math.min(1, Math.sqrt(2200000 / (w * h)));
        W = Math.max(1, Math.round(w * k)); H = Math.max(1, Math.round(h * k));
        if (canvas.width !== W || canvas.height !== H) { canvas.width = W; canvas.height = H; }
      }
      function frame(now) {
        if (lost) return;
        /* start 63s in: a frame with two clear folds, also the still one */
        r.draw(63 + ((now - t0) / 1000) * speed * (reduce ? 0 : 1), W, H);
        if (!state.frames) canvas.classList.add('is-live');
        state.frames++;
      }
      function loop(now) {
        raf = null; frame(now);
        if (visible && !reduce && !document.hidden && !lost) raf = requestAnimationFrame(loop);
      }
      function kick() { if (!raf) raf = requestAnimationFrame(loop); }

      canvas.addEventListener('webglcontextlost', function (e) {
        e.preventDefault(); lost = true; canvas.classList.remove('is-live');
      });
      size();
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () { size(); if (reduce || !raf) frame(performance.now()); }).observe(wrap);
      } else {
        window.addEventListener('resize', function () { size(); if (reduce) frame(performance.now()); });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { visible = e.isIntersecting; if (visible) kick(); });
        }, { rootMargin: '200px 0px' }).observe(sec);
      }
      document.addEventListener('visibilitychange', function () { if (!document.hidden && visible) kick(); });
      kick();
    }

    function init() { document.querySelectorAll('[data-social-proof]').forEach(start); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', function (e) {
      var sec = e.target && e.target.querySelector ? e.target.querySelector('[data-social-proof]') : null;
      if (sec) start(sec);
    });
  })();
  (function () {
    /* "Load more": reveal the next batch of hidden cards. Once every card is
       out the button turns into "Show less", which folds the grid back to its
       first row and brings the grid's top back into view. The button only
       hides when there was never anything to reveal. */
    document.querySelectorAll('[data-sp-grid]').forEach(function (root) {
      var btn = root.querySelector('[data-sp-more]');
      var wrap = root.querySelector('[data-sp-more-wrap]');
      if (!btn) return;
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sp-slide]'));
      var labels = btn.querySelectorAll('[data-sp-label]');
      var phone = window.matchMedia('(max-width: 749px)');
      var FIRST = 4;
      function shown(li) { return !li.hidden && getComputedStyle(li).display !== 'none'; }
      function pending() { return slides.filter(function (li) { return !shown(li); }); }
      function expanded() { return slides.some(function (li) { return li.classList.contains('is-on'); }); }
      function label(text) { labels.forEach(function (el) { el.textContent = text; }); }
      function sync() {
        var left = pending().length;
        var less = left === 0 && expanded();
        if (wrap) wrap.hidden = left === 0 && !less;
        btn.setAttribute('aria-expanded', less ? 'true' : 'false');
        label(less ? btn.getAttribute('data-label-less') : btn.getAttribute('data-label-more'));
      }
      btn.addEventListener('click', function () {
        if (pending().length === 0 && expanded()) {
          slides.forEach(function (li, i) {
            li.classList.remove('is-on');
            if (i >= FIRST) li.hidden = true;
          });
          sync();
          var top = root.getBoundingClientRect().top;
          if (top < 0) window.scrollTo({ top: window.pageYOffset + top - 120, behavior: 'smooth' });
          return;
        }
        var step = phone.matches ? 4 : (parseInt(root.getAttribute('data-sp-step'), 10) || 8);
        pending().slice(0, step).forEach(function (li) { li.hidden = false; li.classList.add('is-on'); });
        sync();
      });
      window.addEventListener('resize', sync);
      sync();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["trustpilot-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Load Trustpilot's bootstrap once, and only when a widget is on the page. */
    if (!document.querySelector('.trustpilot-widget')) return;
    if (document.querySelector('script[data-trustpilot-bootstrap]')) return;
    var s = document.createElement('script');
    s.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    s.async = true;
    s.setAttribute('data-trustpilot-bootstrap', '');
    document.head.appendChild(s);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* UGC strip: drives the marquee from JS so hovering no longer pauses it
       and the visitor can drag it either way. One loop is a full row plus
       the gap between the two copies, crossed in 70s like the CSS version.
       After a drag the strip glides with the throw and eases back to its
       cruising speed. */
    function start(track) {
      if (track.__ugcDrag) return;
      track.__ugcDrag = true;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var strip = track.querySelector('.ugc__marquee');
      if (!strip) return;
      track.classList.add('is-draggable');

      var x = 0, loop = 0, vel = 0, last = 0, visible = true;
      var down = false, dragging = false, startX = 0, startY = 0, startOff = 0, lastX = 0, lastT = 0, moved = 0;

      function measure() { loop = strip.offsetWidth / 2 + 5; }
      function cruise() { return loop / 70; }
      function wrap() { if (loop > 0) x = ((x % loop) + loop) % loop; }
      function paint() { strip.style.transform = 'translate3d(' + (-x).toFixed(2) + 'px,0,0)'; }

      function tick(t) {
        var dt = last ? Math.min(0.05, (t - last) / 1000) : 0;
        last = t;
        if (!dragging && visible && loop > 0) {
          vel += (cruise() - vel) * Math.min(1, dt * 2.2);
          x += vel * dt;
          wrap();
          paint();
        }
        requestAnimationFrame(tick);
      }

      function onMove(e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!dragging) {
          if (Math.abs(dx) < 6) return;
          if (e.pointerType !== 'mouse' && Math.abs(e.clientY - startY) > Math.abs(dx)) { onUp(); return; }
          dragging = true;
          track.classList.add('is-dragging');
        }
        moved = Math.max(moved, Math.abs(dx));
        x = startOff - dx;
        wrap();
        paint();
        var now = performance.now();
        var dtm = (now - lastT) / 1000;
        if (dtm > 0) vel = -(e.clientX - lastX) / dtm;
        lastX = e.clientX;
        lastT = now;
      }
      function onUp() {
        if (!down) return;
        down = false;
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
        window.removeEventListener('pointercancel', onUp);
        if (!dragging) return;
        dragging = false;
        track.classList.remove('is-dragging');
        if (performance.now() - lastT > 90) vel = 0;
        vel = Math.max(-2500, Math.min(2500, vel));
      }
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        down = true;
        moved = 0;
        startX = lastX = e.clientX;
        startY = e.clientY;
        startOff = x;
        lastT = performance.now();
        window.addEventListener('pointermove', onMove);
        window.addEventListener('pointerup', onUp);
        window.addEventListener('pointercancel', onUp);
      });
      /* A drag must not open the tile it started on. */
      track.addEventListener('click', function (e) {
        if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; }
      }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }).observe(track);
      }
      measure();
      window.addEventListener('resize', measure);
      window.addEventListener('load', measure);
      requestAnimationFrame(tick);
    }
    function init() { document.querySelectorAll('.ugc__track').forEach(start); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whitening-fades"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-wf-causes]').forEach(function (root) {
    var track = root.querySelector('[data-wf-track]');
    if (!track) return;
    function step() {
      var tile = track.querySelector('.whitening-fades__tile');
      if (!tile) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0');
      return tile.getBoundingClientRect().width + gap;
    }
    var prev = root.querySelector('[data-wf-prev]');
    var next = root.querySelector('[data-wf-next]');
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  } catch(e) { console.error(e); }
})();
})();
